import { Box, Button, Checkbox, FormControlLabel, IconButton, InputAdornment, Select, Tab, Tabs, TextField, Typography, BaseTextFieldProps, MenuItem, CircularProgress, Container, Stack, Avatar, Skeleton, Tooltip } from '@mui/material'
import React, { useState, useRef, useEffect, useMemo } from 'react'
import { AmyPorterfield, clientPointWhite, dolbyWhite, ewLogo, fb, foundrWhite, keapWhite, linkdin, Logo, LogoDarkMode, mail, microsoft, dayTrialCloud, susieMoore, teachableWhite, } from '../assets/images'
import { GoogleIcon, LinkedInsmallIcon, MicrosoftIcon, RightArrow, TickSymbolThin } from '../assets/icons'
import Grid from '@mui/material/Grid2'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import StarHalfRoundedIcon from '@mui/icons-material/StarHalfRounded';
import umbrellaSignBg from "../assets/images/umbrellaSignBg.png"
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import { CheckboxProps } from '@mui/material/Checkbox';
import 'react-international-phone/style.css';
import { CountryIso2, defaultCountries, FlagImage, parseCountry, usePhoneInput, } from 'react-international-phone';
import AuthService from '../services/auth.service'
import { useNavigate, useSearchParams } from 'react-router-dom'
import AccountVerification from '../modals/AccountVerification'
import moment from 'moment-timezone';
import { CardComponent } from "@chargebee/chargebee-js-react-wrapper";
import chargebeeService from '../services/chargebee.service'
import { Applications } from '../types/enums'
import { toast } from 'react-toastify'
import { SocialProvider } from '../types/auth'
import { config } from '../config'
import theme from '../theme'
import { LIVE_PRICES, AUTOMATED_PRICES, LIVE_AUTO_PRICES, PricingTier } from '../components/subscription/pricing/pricingData';
import { formatPlanName, validateEmail, generateSecurePassword } from '../utils/common.util'
import { LeadsquaredService } from '../services/leadsquared/leadsquared.service'
import { PLAN_NAMES } from '../constants/planNames'
import { ArrowForward } from '@mui/icons-material'
import { decodeMetadataToken } from '../utils/token.utils';
import { logEvent, EVENT_TYPES, SIGNUP_STEPS, SIGNUP_FLOWS } from '../utils/events.util'
import PasswordStrengthIndicator from '../components/common/PasswordStrengthIndicator'

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const Signup2ndFlow = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const isSSOFlow = searchParams.get('isSSOFlow') === 'true';
    const authKey = searchParams.get('authKey') || searchParams.get('authkey');
    const emailFromUrl = searchParams.get('email');
    
    const [showPassword, setShowPassword] = React.useState(false);
    const [showPromoField, setShowPromoField] = useState(false);
    const [value, setValue] = React.useState(0);
    const [passwordError, setPasswordError] = useState('');
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [termsError, setTermsError] = useState('');
    const [leadSquaredId, setLeadSquaredId] = useState<string>('');

    const getTimezoneString = () => {
        const timezone = moment.tz.guess() || "UTC";
        const offset = moment.tz(timezone).format("Z");
        const zoneName = moment.tz(timezone).zoneName();
        return `(GMT${offset}),${timezone},${zoneName}`;
    };

    const generateFirstName = (email: string) => {
        const emailParts = email.split("@")[0];
        const name = emailParts
            .split(/[._-]/)
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
            .join(" ");
        return name;
    };

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        timezone: getTimezoneString(),
        subdomain: ''
    });

    // Auto-generate strong password on component mount
    useEffect(() => {
        const autoGeneratedPassword = generateSecurePassword();
        setFormData(prev => ({
            ...prev,
            password: autoGeneratedPassword
        }));
    }, []);
    const [formErrors, setFormErrors] = useState({
        email: '',
        password: '',
        subdomain: ''
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isMaybeLaterLoading, setIsMaybeLaterLoading] = useState(false);
    const [isCardReady, setIsCardReady] = useState(false);
    const [isCardValid, setIsCardValid] = useState(false);

    const [verificationData, setVerificationData] = useState({
        companyId: '',
        companyName: '',
        infLeadSquaredId: ''
    });

    const [cardToken, setCardToken] = useState<string>("");
    const [cardError, setCardError] = useState<string | null>(null);
    const cardRef = useRef<any>(null);

    // planId is managed internally and not read/written from/to URL
    // Default to Yearly USD for now, but keep builder for future period/currency toggles
    const [planId, setPlanId] = useState<string>('Live-Webinars-USD-Yearly');
    const [currency, setCurrency] = useState<string>('USD');
    const [planDetails, setPlanDetails] = useState<any>(null);
    const [isLoadingPlan, setIsLoadingPlan] = useState(false);
    const [isTrial, setIsTrial] = useState(false);
    const [monthlyPlanDetails, setMonthlyPlanDetails] = useState<any>(null);
    const [initialPlanId, setInitialPlanId] = useState<string | null>(null);

    const [promoCode, setPromoCode] = useState('');
    const [appliedPromo, setAppliedPromo] = useState<{
        code: string;
        discount: number;
        type: string;
    } | null>(null);
    const [promoError, setPromoError] = useState('');

    const [domainSuggestions, setDomainSuggestions] = useState<string[]>([]);
    const [currentStep, setCurrentStep] = useState<'signup' | 'webinar-type' | 'full-offer-table' | 'attendee-count' | 'payment-method'>(
        isSSOFlow || emailFromUrl ? 'webinar-type' : 'signup'
    );
    const [selectedWebinarType, setSelectedWebinarType] = useState<'live' | 'automated' | 'live-automated'>('live-automated');
    const [selectedAttendeeCount, setSelectedAttendeeCount] = useState<number | null>(null);
    const [shouldAutoProceed, setShouldAutoProceed] = useState(false);

    // Billing period derived from internal planId; default to Yearly
    const [isYearly, setIsYearly] = useState(true);
    useEffect(() => {
        setIsYearly(planId.includes('Yearly'));
    }, [planId]);

    // Handle authKey from URL - decode and auto-fill form data
    useEffect(() => {
        
        if (authKey) {
            try {
                // Decode the authKey (it's base64 encoded)
                const decodedAuthKey = atob(authKey);
                
                // Split by colon to get email and password
                const [email, password] = decodedAuthKey.split(':');

                
                if (email && password) {
                    const trimmedEmail = email.trim();
                    const trimmedPassword = password.trim();
                    
                    
                    // Update form data with decoded email and password
                    setFormData(prev => ({
                        ...prev,
                        email: trimmedEmail,
                        password: trimmedPassword
                    }));
                    
                    // Clear any existing errors
                    setFormErrors(prev => ({
                        ...prev,
                        email: '',
                        password: ''
                    }));
                    setPasswordError('');
                    
                    // Set flag to auto-proceed after form data is updated
                    setShouldAutoProceed(true);
                    
                } else {
                    console.error('Invalid authKey format. Expected format: email:password');
                }
            } catch (error) {
                console.error('Failed to decode authKey:', error);
            }
        } else {
            console.log('No authKey found in URL');
        }
    }, [authKey, searchParams]);

    // Handle email parameter from URL - auto-fill email and execute first step processing
    useEffect(() => {
        if (emailFromUrl && !authKey) {
            console.log('Email parameter detected in URL:', emailFromUrl);
            // Validate email format
            const emailValidation = validateEmail(emailFromUrl);
            if (emailValidation.isValid) {
                console.log('Email validation passed, proceeding with first step processing');
                // Update form data with email from URL
                setFormData(prev => ({
                    ...prev,
                    email: emailFromUrl.trim()
                }));
                
                // Clear any existing email errors
                setFormErrors(prev => ({
                    ...prev,
                    email: ''
                }));
                
                // Execute first step processing
                executeFirstStepProcessing(emailFromUrl.trim());
            } else {
                console.error('Invalid email format in URL parameter:', emailFromUrl);
                toast.error('Invalid email format in URL parameter');
            }
        }
    }, [emailFromUrl, authKey]);

    // Auto-proceed after authKey processing is complete
    useEffect(() => {
        if (shouldAutoProceed && formData.email && formData.password) {
            setShouldAutoProceed(false); // Reset flag
            handleNext();
        }
    }, [shouldAutoProceed, formData.email, formData.password]);

    // Remove authKey and email from URL after moving to second step
    useEffect(() => {
        if (currentStep === 'webinar-type' && (authKey || emailFromUrl)) {
            
            // Create new URL without authKey and email parameters
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.delete('authKey');
            newSearchParams.delete('authkey'); // Remove both cases
            newSearchParams.delete('email'); // Remove email parameter
            
            const newUrl = `${window.location.pathname}${newSearchParams.toString() ? '?' + newSearchParams.toString() : ''}`;
            
            // Replace the current URL without triggering a page reload
            window.history.replaceState({}, '', newUrl);
        }
    }, [currentStep, authKey, emailFromUrl, searchParams]);

    // Helper: Determine the actual plan type based on webinar type and attendee count
    const getActualPlanType = (
        webinarType: 'live' | 'automated' | 'live-automated',
        attendeeCount: number
    ): 'live' | 'automated' | 'live-automated' => {
        // Special logic for live webinar type
        if (webinarType === 'live') {
            if (attendeeCount === 50) {
                return 'live'; // Use Live-Webinars plan
            } else {
                return 'live-automated'; // Use All-In-One plan for 200, 500, 1000
            }
        }
        return webinarType; // For automated and live-automated, use as-is
    };

    // Helper: Build planId from webinar type, currency and period; optionally append attendee suffix
    const buildPlanId = (
        type: 'live' | 'automated' | 'live-automated',
        newIsYearly: boolean,
        curr: string,
        attendeeNumber?: string
    ) => {
        const productMap: Record<'live' | 'automated' | 'live-automated', string> = {
            live: 'Live-Webinars',
            automated: 'Automated-Gold',
            'live-automated': 'All-In-One'
        };
        const period = newIsYearly ? 'Yearly' : 'Monthly';
        const base = `${productMap[type]}-${curr}-${period}`;
        return attendeeNumber ? `${base}-${attendeeNumber}` : base;
    };

    // Update internal planId when billing period changes (do not add attendee suffix unless present)
    const updatePlanForPeriod = (newIsYearly: boolean) => {
        const attendeeMatch = planId.match(/-(\d+)$/);
        const attendeeNumber = attendeeMatch ? attendeeMatch[1] : undefined;
        // Determine current webinar type from planId
        let currentType: 'live' | 'automated' | 'live-automated' = 'live-automated';
        if (planId.startsWith('Live-Webinars-')) currentType = 'live';
        else if (planId.startsWith('Automated-Gold-')) currentType = 'automated';
        else if (planId.startsWith('All-In-One-')) currentType = 'live-automated';
        const newPlanId = buildPlanId(currentType, newIsYearly, currency, attendeeNumber);
        setPlanId(newPlanId);
    };

    const handleBillingPeriodChange = (newIsYearly: boolean) => {
        setIsYearly(newIsYearly);
        updatePlanForPeriod(newIsYearly);

        // Swap the plan details without making API calls
        if (planDetails && monthlyPlanDetails) {
            if (newIsYearly) {
                // Switching to yearly: set planDetails to yearly, monthlyPlanDetails to monthly
                setPlanDetails(monthlyPlanDetails); // monthlyPlanDetails contains yearly data
                setMonthlyPlanDetails(planDetails); // planDetails contains monthly data
            } else {
                // Switching to monthly: set planDetails to monthly, monthlyPlanDetails to yearly
                setPlanDetails(monthlyPlanDetails); // monthlyPlanDetails contains monthly data
                setMonthlyPlanDetails(planDetails); // planDetails contains yearly data
            }
        }
    };

    // Track initial plan ID and trial flag based on internal planId
    useEffect(() => {
        if (!initialPlanId) {
            setInitialPlanId(planId);
        }
        setIsTrial(planId === PLAN_NAMES.FREE_TRIAL);
    }, [planId, initialPlanId]);

    // Store planId in localStorage when component mounts
    useEffect(() => {
        if (planId) {
            localStorage.setItem('planId', planId);
        }
    }, [planId]);

    useEffect(() => {
        const fetchPlanDetails = async () => {
            if (!initialPlanId) return;

            const cleanInitialPlanId = initialPlanId.replace(/-\d+$/, '');
            setIsLoadingPlan(true);
            try {
                // Fetch both monthly and yearly plan details at once using clean plan IDs without numbers
                const basePlanId = cleanInitialPlanId.replace(/(Monthly|Yearly)/g, "");
                const monthlyPlanId = `${basePlanId}Monthly`;
                const yearlyPlanId = `${basePlanId}Yearly`;

                // Fetch both plans in parallel
                const [monthlyResponse, yearlyResponse] = await Promise.all([
                    chargebeeService.getPlanById(monthlyPlanId),
                    chargebeeService.getPlanById(yearlyPlanId)
                ]);

                // Store both plan details
                setPlanDetails(isYearly ? yearlyResponse.data : monthlyResponse.data);
                setMonthlyPlanDetails(isYearly ? monthlyResponse.data : yearlyResponse.data);

            } catch (error) {
                console.error('Failed to fetch plan details:', error);
                // Fallback: try to fetch just the current plan
                try {
                    const response = await chargebeeService.getPlanById(cleanInitialPlanId);
                    setPlanDetails(response.data);
                } catch (fallbackError) {
                    console.error('Failed to fetch fallback plan details:', fallbackError);
                }
            } finally {
                setIsLoadingPlan(false);
            }
        };

        fetchPlanDetails();
    }, [initialPlanId]); // Only depend on initialPlanId, not planId

    useEffect(() => {
        // Extract plan details from planId and console log them
        if (planId) {
            // Parse the planId
            const parts = planId.split('-');
            let extractedPlanType: string;
            let currency: string;
            let duration: string;
            let extractedAttendees: number;
            let liveAttendees: number = 0;
            let automatedAttendees: number = 0;

            if (parts[0] === 'All') {
                extractedPlanType = PLAN_NAMES.ALL_IN_ONE; // "All-In-One"
                currency = parts[3]; // USD
                duration = parts[4]; // Yearly/Monthly
                extractedAttendees = parseInt(parts[5]); // e.g., 750

                // Find the matching plan to get the label
                const selectedPlan = LIVE_AUTO_PRICES.find(plan => plan.value === extractedAttendees.toString());
                if (selectedPlan) {
                    // Parse the label to extract live and automated attendees, handling comma-separated numbers
                    const labelMatch = selectedPlan.label.match(/([\d,]+)\s+Live\s+&\s+([\d,]+)\s+Automated/);
                    if (labelMatch) {
                        // Remove commas and convert to numbers
                        liveAttendees = parseInt(labelMatch[1].replace(/,/g, ''));
                        automatedAttendees = parseInt(labelMatch[2].replace(/,/g, ''));
                    }
                }
            } else {
                extractedPlanType = parts[0] + '-' + parts[1]; // Could be LIVE_WEBINARS or AUTOMATED_GOLD
                currency = parts[2]; // USD
                duration = parts[3]; // Yearly/Monthly
                extractedAttendees = parseInt(parts[4]); // e.g., 250
            }

            // Validate that the extracted plan type is one of the valid plan names
            const validPlanTypes = [
                PLAN_NAMES.LIVE_WEBINARS,
                PLAN_NAMES.AUTOMATED_GOLD,
                PLAN_NAMES.ALL_IN_ONE
            ];

            if (!validPlanTypes.includes(extractedPlanType)) {
                console.log('Invalid plan type:', extractedPlanType, 'redirecting to pricing page');
                window.location.href = 'https://easywebinar.com/pricing/';
                return;
            }
        }
    }, [planId]);

         const calculateDynamicPricing = () => {
        if (isLoadingPlan || !planDetails) {
            return {
                currentPrice: '$00.00',
                alternativePrice: '$00.00',
                savings: '$00.00',
                savingsPercentage: 0,
                isYearlySelected: isYearly,
                currentPeriod: isYearly ? 'year' : 'month',
                alternativePeriod: isYearly ? 'month' : 'year',
                monthlyPrice: '$00.00',
                yearlyPrice: '$00.00',
                originalMonthlyPrice: '$00.00',
                originalYearlyPrice: '$00.00'
            };
        }

        const quantity = planId ? parseInt(planId.match(/-(\d+)$/)?.[1] || '0') : 0;

        if (planId === PLAN_NAMES.FREE_TRIAL) {
            return {
                currentPrice: '$00.00',
                alternativePrice: '$00.00',
                savings: '$00.00',
                savingsPercentage: 0,
                isYearlySelected: isYearly,
                currentPeriod: isYearly ? 'year' : 'month',
                alternativePeriod: isYearly ? 'month' : 'year',
                monthlyPrice: '$00.00',
                yearlyPrice: '$00.00',
                originalMonthlyPrice: '$00.00',
                originalYearlyPrice: '$00.00'
            };
        }

        // Find the current plan tier
        const currentTier = planDetails?.tiers.find((tier: any) => {
            if (!tier.ending_unit) {
                return quantity >= tier.starting_unit;
            }
            return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
        });

        if (!currentTier) {
            return {
                currentPrice: '$00.00',
                alternativePrice: '$00.00',
                savings: '$00.00',
                savingsPercentage: 0,
                isYearlySelected: isYearly,
                currentPeriod: isYearly ? 'year' : 'month',
                alternativePeriod: isYearly ? 'month' : 'year',
                monthlyPrice: '$00.00',
                yearlyPrice: '$00.00',
                originalMonthlyPrice: '$00.00',
                originalYearlyPrice: '$00.00'
            };
        }

        // Get current plan price
        const currentPrice = currentTier.price / 100; // Convert cents to dollars
        let discountedCurrentPrice = currentPrice;

        // Apply discount if promo code is applied
        if (appliedPromo) {
            if (appliedPromo.type === 'percentage') {
                discountedCurrentPrice = currentPrice * (1 - appliedPromo.discount / 100);
            } else if (appliedPromo.type === 'fixed_amount') {
                discountedCurrentPrice = Math.max(0, currentPrice - (appliedPromo.discount / 100));
            }
        }

        // Calculate alternative pricing
        let alternativePrice = 0;
        let alternativeTier = null;

        if (isYearly) {
            // If yearly is selected, calculate monthly equivalent
            if (monthlyPlanDetails) {
                // Use the fetched monthly plan details
                alternativeTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (alternativeTier) {
                    alternativePrice = alternativeTier.price / 100; // Convert cents to dollars

                    // Apply same discount to alternative price
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            alternativePrice = alternativePrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            alternativePrice = Math.max(0, alternativePrice - (appliedPromo.discount / 100));
                        }
                    }

                    // Calculate yearly equivalent of monthly price
                    alternativePrice = alternativePrice * 12;
                } else {
                    // Fallback: estimate monthly price as 1/12 of yearly price
                    alternativePrice = currentPrice;
                }
            } else {
                // Fallback: estimate monthly price as 1/12 of yearly price
                alternativePrice = currentPrice;
            }
        } else {
            // If monthly is selected, calculate yearly equivalent
            if (monthlyPlanDetails) {
                // Use the fetched monthly plan details
                alternativeTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (alternativeTier) {
                    alternativePrice = alternativeTier.price / 100; // Convert cents to dollars

                    // Apply same discount to alternative price
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            alternativePrice = alternativePrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            alternativePrice = Math.max(0, alternativePrice - (appliedPromo.discount / 100));
                        }
                    }

                    // Calculate yearly equivalent of monthly price
                    alternativePrice = alternativePrice * 12;
                } else {
                    // Fallback: estimate yearly price as 12x monthly price
                    alternativePrice = currentPrice * 12;
                }
            } else {
                // Fallback: estimate yearly price as 12x monthly price
                alternativePrice = currentPrice * 12;
            }
        }

        // Calculate static monthly and yearly prices
        let monthlyPrice = 0;
        let monthlyPriceOriginalValue = 0;
        let yearlyPrice = 0;
        let yearlyPriceOriginalValue = 0;

        // Calculate monthly price
        if (isYearly) {
            // If yearly is selected, use the monthly plan details
            if (monthlyPlanDetails) {
                const monthlyTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (monthlyTier) {
                    monthlyPriceOriginalValue = monthlyTier.price / 100; // Convert cents to dollars
                    monthlyPrice = monthlyPriceOriginalValue;
                    // Apply discount if promo code is applied
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            monthlyPrice = monthlyPrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            monthlyPrice = Math.max(0, monthlyPrice - (appliedPromo.discount / 100));
                        }
                    }
                }
            }
        } else {
            // If monthly is selected, use the current plan details
            if (planDetails && planDetails.periodUnit === 'month') {
                const monthlyTier = planDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (monthlyTier) {
                    monthlyPriceOriginalValue = monthlyTier.price / 100; // Convert cents to dollars
                    monthlyPrice = monthlyPriceOriginalValue;
                    // Apply discount if promo code is applied
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            monthlyPrice = monthlyPrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            monthlyPrice = Math.max(0, monthlyPrice - (appliedPromo.discount / 100));
                        }
                    }
                }
            }
        }

        // Calculate yearly price (monthly equivalent)
        if (isYearly) {
            // If yearly is selected, use the current yearly price
            yearlyPrice = discountedCurrentPrice / 12;
        } else {
            // If monthly is selected, use the actual yearly price from alternative plan details
            if (monthlyPlanDetails && monthlyPlanDetails.periodUnit === 'year') {
                // Use the fetched yearly plan details
                const yearlyTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (yearlyTier) {
                    let yearlyPriceValue = yearlyTier.price / 100; // Convert cents to dollars
                    // Apply discount if promo code is applied
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            yearlyPriceValue = yearlyPriceValue * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            yearlyPriceValue = Math.max(0, yearlyPriceValue - (appliedPromo.discount / 100));
                        }
                    }
                    yearlyPrice = yearlyPriceValue / 12;
                } else {
                    // Fallback: estimate yearly price as 12x monthly price
                    yearlyPrice = discountedCurrentPrice;
                }
            } else {
                // Fallback: estimate yearly price as 12x monthly price
                yearlyPrice = discountedCurrentPrice;
            }
        }

        // Calculate savings
        let savings = 0;
        let savingsPercentage = 0;

        if (isYearly) {
            // If yearly is selected, savings = monthly equivalent - yearly price
            savings = Math.abs(alternativePrice - discountedCurrentPrice);
            savingsPercentage = alternativePrice > 0 ? Math.round((savings / alternativePrice) * 100) : 0;
        } else {
            // If monthly is selected, savings = (monthly price × 12) - actual yearly price
            const yearlyEquivalent = monthlyPrice * 12;
            const actualYearlyPrice = monthlyPlanDetails ?
                (monthlyPlanDetails.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                })?.price || 0) / 100 : 0;

            // Apply discount to yearly price if promo code is applied
            let discountedYearlyPrice = actualYearlyPrice;
            if (appliedPromo && actualYearlyPrice > 0) {
                if (appliedPromo.type === 'percentage') {
                    discountedYearlyPrice = actualYearlyPrice * (1 - appliedPromo.discount / 100);
                } else if (appliedPromo.type === 'fixed_amount') {
                    discountedYearlyPrice = Math.max(0, actualYearlyPrice - (appliedPromo.discount / 100));
                }
            }

            savings = Math.abs(yearlyEquivalent - discountedYearlyPrice);
            savingsPercentage = discountedYearlyPrice > 0 ? Math.round((savings / discountedYearlyPrice) * 100) : 0;
        }

        return {
            currentPrice: `$${Math.round(discountedCurrentPrice)}`,
            alternativePrice: `$${Math.round(alternativePrice)}`,
            savings: `$${Math.round(savings)}`,
            savingsPercentage,
            isYearlySelected: isYearly,
            currentPeriod: isYearly ? 'year' : 'month',
            alternativePeriod: isYearly ? 'month' : 'year',
            currentPriceValue: discountedCurrentPrice || 0,
            alternativePriceValue: alternativePrice || 0,
            monthlyPrice: `$${Math.round(monthlyPrice)}`,
            yearlyPrice: `$${Math.round(yearlyPrice)}`,
            originalMonthlyPrice: `$${Math.round(monthlyPriceOriginalValue)}`,
            originalYearlyPrice: `$${Math.round(yearlyPriceOriginalValue)}`
        };
    };

    const validatePassword = (password: string) => {
        const minLength = 8;
        const hasNumber = /\d/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        const hasLowercase = /[a-z]/.test(password);
        const hasUppercase = /[A-Z]/.test(password);

        if (password.length < minLength) {
            return 'Password must be at least 8 characters long';
        }
        if (!hasNumber) {
            return 'Password must contain at least one number';
        }
        if (!hasSpecialChar) {
            return 'Password must contain at least one special character';
        }
        if (!hasUppercase) {
            return 'Password must contain at least one uppercase letter';
        }
        if (!hasLowercase) {
            return 'Password must contain at least one lowercase letter';
        }
        return '';
    };



    const validateForm = () => {
        const errors = {
            email: '',
            password: '',
            subdomain: ''
        };
        let isValid = true;

        // Check required fields
        const emailValidation = validateEmail(formData.email);
        if (!emailValidation.isValid) {
            errors.email = emailValidation.error || "Please enter a valid email";
            isValid = false;
        }

        // Password validation
        if (!formData.password.trim()) {
            errors.password = 'Password is required';
            setPasswordError('Password is required');
            isValid = false;
        } else {
            const passwordValidationError = validatePassword(formData.password);
            if (passwordValidationError) {
                errors.password = passwordValidationError;
                setPasswordError(passwordValidationError);
                isValid = false;
            } else {
                setPasswordError('');
            }
        }

        setFormErrors(errors);
        return isValid;
    };


    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        // For subdomain field, convert to lowercase
        const processedValue = name === 'subdomain' ? value.toLowerCase() : value;

        // Update the form data with the raw input value
        setFormData(prev => ({
            ...prev,
            [name]: processedValue
        }));

        // Clear error when user starts typing
        setFormErrors(prev => ({
            ...prev,
            [name]: ''
        }));

        if (name === 'password') {
            if (!value.trim()) {
                setPasswordError('Password is required');
            } else {
                setPasswordError(validatePassword(value));
            }
        }
    };



    const handleTermsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAcceptedTerms(event.target.checked);
        if (event.target.checked) {
            setTermsError('');
        }
    };

    const [verificationDialogOpen, setVerificationDialogOpen] = React.useState(false);

    const handleVerificationDialogOpen = () => {
        setVerificationDialogOpen(true);
    };

    const handleVerificationDialogClose = async () => {
        setVerificationDialogOpen(false);
        const leadData = {
            "leadId": leadSquaredId,
            "fields": [
                { "Attribute": "mx_Plan_Name", "Value": planId },
                { "Attribute": "mx_Status", "Value": "Pending Verification" }
            ]
        }
        await LeadsquaredService.updateLsField(leadData);
        navigate('/login');
    };

    // Helper function to clear UTM params from localStorage
    const clearUtmParamsFromStorage = () => {
        localStorage.removeItem('utm_source');
        localStorage.removeItem('utm_medium');
        localStorage.removeItem('utm_campaign');
        localStorage.removeItem('utm_content');
        localStorage.removeItem('utm_term');
        localStorage.removeItem('ad_id');
        localStorage.removeItem('fbc_id');
        localStorage.removeItem('h_ad_id');
        localStorage.removeItem('utm_id');
        localStorage.removeItem('gc_id');
        localStorage.removeItem('h_ga_id');
        localStorage.removeItem('h_keyword_id');
        localStorage.removeItem('h_keyword');
        localStorage.removeItem('h_placement');
        localStorage.removeItem('g_special_campaign');
    };

    const handleVerificationDialogProceed = async () => {
        // handleVerificationDialogClose();
        setVerificationDialogOpen(false);
        await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Email Verified" });
        const leadData = {
            "leadId": leadSquaredId,
            "fields": [
                { "Attribute": "mx_Plan_Name", "Value": isTrial ? PLAN_NAMES.FREE_TRIAL : planId },
                { "Attribute": "mx_Status", "Value": "Active" }
            ]
        }
        await LeadsquaredService.updateLsField(leadData);

        // Clear UTM parameters from localStorage after successful signup
        clearUtmParamsFromStorage();

        // Prepare plan data for tracking
        const priceData = getPlanPrice();
        const purchaseValue = isTrial ? 0.0 : priceData.discountedPrice;
        const userSelection = localStorage.getItem('user_selection');
        const customerType = (userSelection === 'full_access') ? 'with_cc' : 'without_cc';

        // Pass plan data through URL parameters
        const planData = {
            price: purchaseValue,
            currency: 'USD',
            coupon: appliedPromo?.code || '',
            plan_name: planDetails?.name || planId || 'Unknown Plan',
            customer_type: customerType
        };

        // Encode plan data as URL parameters
        const planDataParams = new URLSearchParams({
            ...planData,
            price: planData.price.toString()
        }).toString();

        window.location.href = `/loading-dashboard?ew_email=${formData.email}&planId=${isTrial ? PLAN_NAMES.FREE_TRIAL : planId}&companyId=${encodeURIComponent(verificationData.companyId)}&${planDataParams}`;
    };

    const BpIcon = styled('span')(({ theme }) => ({
        borderRadius: 4,
        width: 24,
        height: 24,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#fff',

        'input:hover ~ &': {
            border: '1px solid #666666',
        },
    }));

    const BpCheckedIcon = styled(BpIcon)({
        '&::before': {
            display: 'block',
            width: 24,
            height: 24,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fillRule='evenodd' clipRule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input ~ &': {
            backgroundColor: '#178EFC',
            border: 'none',
        },

        'input:hover ~ &': {
            border: 'none',
        }
    });

    function BpCheckbox(props: CheckboxProps) {
        return (
            <Checkbox
                sx={{ '&:hover': { bgcolor: 'transparent' } }}
                disableRipple
                color="default"
                checkedIcon={<BpCheckedIcon />}
                icon={<BpIcon />}
                {...props}
            />
        );
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        // Only allow changing to the second tab (newValue = 1) if it's done programmatically
        // Users can always go back to the first tab (newValue = 0)
        if (newValue === 0) {
            setValue(newValue);
        }
        // The second tab (newValue = 1) can only be reached through handleNext function
        // which validates the form fields first
    }

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleSocialSignIn = (provider: SocialProvider) => {
        try {
            const authUrl = config.sso_auth_url;
            const planIdParam = planId;

            const utmParams = {
                utm_source: localStorage.getItem('utm_source'),
                utm_medium: localStorage.getItem('utm_medium'),
                utm_campaign: localStorage.getItem('utm_campaign'),
                utm_content: localStorage.getItem('utm_content'),
                utm_term: localStorage.getItem('utm_term'),
                ad_id: localStorage.getItem('ad_id'),
                fbc_id: localStorage.getItem('fbc_id'),
                h_ad_id: localStorage.getItem('h_ad_id'),
                utm_id: localStorage.getItem('utm_id'),
                gc_id: localStorage.getItem('gc_id'),
                h_ga_id: localStorage.getItem('h_ga_id'),
                h_keyword_id: localStorage.getItem('h_keyword_id'),
                h_keyword: localStorage.getItem('h_keyword'),
                h_placement: localStorage.getItem('h_placement'),
                g_special_campaign: localStorage.getItem('g_special_campaign'),
            }

            // Filter out null/undefined/empty values from UTM params
            const cleanUtmParams = Object.entries(utmParams)
                .filter(([_, value]) => value !== null && value !== undefined && value.trim() !== '')
                .reduce((acc, [key, value]) => ({ ...acc, [key]: value?.trim() }), {});

            // Create state parameter with additional metadata
            const stateData = {
                isRegistration: true,
                timestamp: Date.now(),
                flow: 'second-flow',
                ...(planIdParam && { planId: planIdParam }), // Only include planId if it exists
                ...(Object.keys(cleanUtmParams).length > 0 && { utm_params: cleanUtmParams }) // Only include UTM params if they exist
            };

            const baseParams = {
                client_id: config.sso_client_id,
                response_type: 'code',
                scope: 'email openid profile phone',
                redirect_uri: `${window.location.origin}/auth/sso/callback`,
                state: JSON.stringify(stateData),
                prompt: 'select_account'
            };

            const params = new URLSearchParams({
                ...baseParams,
                identity_provider: provider,
            });

            window.location.href = `${authUrl}?${params.toString()}`;
        } catch (error) {
            console.error('Google Sign In Error:', error);
            toast.error('Failed to initialize Google Sign In');
        }
    };

    const handleGoogleSignIn = () => handleSocialSignIn('Google');
    const handleMicrosoftSignIn = () => handleSocialSignIn('Microsoft');
    const handleLinkedinSignIn = () => handleSocialSignIn('Linkedin');

    // Execute first step processing when email comes from URL parameter
    const executeFirstStepProcessing = async (email: string) => {
        try {
            console.log('Starting first step processing for email:', email);
            setIsLoading(true);

            // Check if email exists
            console.log('Checking if email exists...');
            const emailCheckResponse = await AuthService.checkEmailExists(email);
            if (emailCheckResponse.data?.exists) {
                console.log('Email already exists, showing error');
                toast.error("An account with this email already exists. Please use a different email or try logging in.");
                setIsLoading(false);
                return;
            }
            console.log('Email does not exist, proceeding with processing');

            // Auto-generate firstName and lastName from email
            const firstName = generateFirstName(email);
            const lastName = "";

            // Generate subdomain from first name
            const baseSubdomain = firstName.toLowerCase().trim().replace(/\s+/g, '');
            const subdomainResponse = await AuthService.generateSubdomain(baseSubdomain, Applications.EASYWEBINAR);

            // Store the generated subdomain for use in step 2
            setFormData(prev => ({
                ...prev,
                subdomain: subdomainResponse.subdomain
            }));

            // Create lead in Leadsquared
            try {
                let utm_Data = {
                    utm_source: localStorage.getItem('utm_source'),
                    utm_medium: localStorage.getItem('utm_medium'),
                    utm_campaign: localStorage.getItem('utm_campaign'),
                    utm_content: localStorage.getItem('utm_content'),
                    utm_term: localStorage.getItem('utm_term'),
                    ad_id: localStorage.getItem('ad_id'),
                    fbc_id: localStorage.getItem('fbc_id'),
                    h_ad_id: localStorage.getItem('h_ad_id'),
                    utm_id: localStorage.getItem('utm_id'),
                    gc_id: localStorage.getItem('gc_id'),
                    h_ga_id: localStorage.getItem('h_ga_id'),
                    h_keyword_id: localStorage.getItem('h_keyword_id'),
                    h_keyword: localStorage.getItem('h_keyword'),
                    h_placement: localStorage.getItem('h_placement'),
                    g_special_campaign: localStorage.getItem('g_special_campaign'),
                }

                // Create form data with generated firstName and lastName
                const formDataWithDetails = {
                    firstName,
                    lastName,
                    email: email,
                    password: formData.password,
                    timezone: getTimezoneString(),
                    subdomain: subdomainResponse.subdomain,
                };

                const LsId = await LeadsquaredService.createtLead(formDataWithDetails, "", utm_Data);
                await LeadsquaredService.joinActivity({ id: LsId, activityEvent: 201, activityValue: "Signup Attempt - homepage" });
                const leadData = {
                    "leadId": LsId,
                    "fields": [
                        { "Attribute": "mx_Source_lp", "Value": searchParams.get('Source_IP'), },
                    ]
                }
                await LeadsquaredService.updateLsField(leadData);
                setLeadSquaredId(LsId);
            } catch (error: any) {
                console.error('Error creating lead:', error);
            }
            console.log('First step processing completed successfully');
        } catch (error: any) {
            console.error('Error in first step processing:', error);
            toast.error('Failed to process email. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleNext = async () => {
        try {
            setIsLoading(true);

            // Validation and display errors
            const isValid = validateForm();
            if (!isValid) {
                return;
            }

            // Check if email exists
            const emailCheckResponse = await AuthService.checkEmailExists(formData.email);
            if (emailCheckResponse.data?.exists) {
                toast.error("An account with this email already exists. Please use a different email or try logging in.");
                setIsLoading(false);
                return;
            }

            // Auto-generate firstName and lastName from email
            const firstName = generateFirstName(formData.email);
            const lastName = "";

            // Generate subdomain from first name
            const baseSubdomain = firstName.toLowerCase().trim().replace(/\s+/g, '');
            const subdomainResponse = await AuthService.generateSubdomain(baseSubdomain, Applications.EASYWEBINAR);

            // Store the generated subdomain for use in step 2
            setFormData(prev => ({
                ...prev,
                subdomain: subdomainResponse.subdomain
            }));

            // If validation and subdomain generation passes, move to second step
            setCurrentStep('webinar-type');
            try {
                let utm_Data = {
                    utm_source: localStorage.getItem('utm_source'),
                    utm_medium: localStorage.getItem('utm_medium'),
                    utm_campaign: localStorage.getItem('utm_campaign'),
                    utm_content: localStorage.getItem('utm_content'),
                    utm_term: localStorage.getItem('utm_term'),
                    ad_id: localStorage.getItem('ad_id'),
                    fbc_id: localStorage.getItem('fbc_id'),
                    h_ad_id: localStorage.getItem('h_ad_id'),
                    utm_id: localStorage.getItem('utm_id'),
                    gc_id: localStorage.getItem('gc_id'),
                    h_ga_id: localStorage.getItem('h_ga_id'),
                    h_keyword_id: localStorage.getItem('h_keyword_id'),
                    h_keyword: localStorage.getItem('h_keyword'),
                    h_placement: localStorage.getItem('h_placement'),
                    g_special_campaign: localStorage.getItem('g_special_campaign'),
                }

                // Create form data with generated firstName and lastName
                const formDataWithDetails = {
                    firstName,
                    lastName,
                    email: formData.email,
                    password: formData.password,
                    timezone: getTimezoneString(),
                    subdomain: subdomainResponse.subdomain,
                };

                const LsId = await LeadsquaredService.createtLead(formDataWithDetails, "", utm_Data);
                await LeadsquaredService.joinActivity({ id: LsId, activityEvent: 201, activityValue: "Signup Attempt - homepage" });
                const leadData = {
                    "leadId": LsId,
                    "fields": [
                        { "Attribute": "mx_Source_lp", "Value": searchParams.get('Source_IP'), },
                    ]
                }
                await LeadsquaredService.updateLsField(leadData);
                setLeadSquaredId(LsId);
            } catch (error: any) {
                console.error('Error creating lead:', error);
            }
        } catch (error: any) {
            console.error('Error generating subdomain:', error);
            toast.error('Failed to generate subdomain. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleWebinarTypeSelection = () => {
        // Handle webinar type selection completion
        
        // Set default attendees based on webinar type
        let defaultAttendees: number;
        switch (selectedWebinarType) {
            case 'live':
                defaultAttendees = 50;
                break;
            case 'automated':
                defaultAttendees = 200;
                break;
            case 'live-automated':
                defaultAttendees = 250;
                break;
            default:
                defaultAttendees = 50;
        }
        
        setSelectedAttendeeCount(defaultAttendees);
        
        setCurrentStep('full-offer-table');

        // Ensure plan details are fetched if no attendee was changed
        // This calls the same logic as handleAttendeeSelection to fetch plan details
        if (selectedAttendeeCount) {
            const actualPlanType = getActualPlanType(selectedWebinarType, selectedAttendeeCount);
            const newPlanId = buildPlanId(actualPlanType, isYearly, currency, String(selectedAttendeeCount));
            setPlanId(newPlanId);
            setInitialPlanId(newPlanId);
        }
        
        try {
            LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Plan choose : " + selectedWebinarType});
        } catch (error) {
            console.error('Error joining activity:', error);
        }
    };

    const handleFullOfferTableSelection = () => {
        // Handle full offer table selection completion
        LeadsquaredService.joinActivity({
            id: leadSquaredId,
            activityEvent: 205,
            activityValue: "Proceed Full Access"
        });
        // Mark that user clicked "Full Access" (with credit card)
        localStorage.setItem('user_selection', 'full_access');
        // Proceed to attendee count step
        setCurrentStep('attendee-count');
    };

    // Single function for attendee selection that works in both steps
    const handleAttendeeSelection = (attendeeNumber: number) => {
        
        // Update the selected attendee count
        setSelectedAttendeeCount(attendeeNumber);
        
        // Determine the actual plan type based on webinar type and attendee count
        const actualPlanType = getActualPlanType(selectedWebinarType, attendeeNumber);
        
        // Build planId using the actual plan type and attendee number
        const newPlanId = buildPlanId(actualPlanType, isYearly, currency, String(attendeeNumber));
        setPlanId(newPlanId);
        setInitialPlanId(newPlanId);
    };

    const handleAttendeeCountSelection = () => {
        if (selectedAttendeeCount) {
            setCurrentStep('payment-method');
        }
    };


    // Build attendee options based on selected webinar type
    const attendeeCountOptions = React.useMemo(() => {
        switch (selectedWebinarType) {
            case 'live':
                return [50, 200, 500, 1000];
            case 'automated':
                return [3000, 6000, 10000];
            case 'live-automated':
                return [200, 500, 1000];
            default:
                return [50, 200, 500, 1000];
        }
    }, [selectedWebinarType]);

    // Ensure a default selection: pick first option, and reset if current selection is not in the new list
    useEffect(() => {
        if (attendeeCountOptions.length > 0) {
            if (
                selectedAttendeeCount === null ||
                !attendeeCountOptions.includes(selectedAttendeeCount)
            ) {
                setSelectedAttendeeCount(attendeeCountOptions[0]);
            }
        }
    }, [attendeeCountOptions, selectedAttendeeCount]);


    const getPlanPrice = () => {
        if (!planDetails || !selectedAttendeeCount) {
            return { price: 0, discountedPrice: 0 };
        }

        const tier = planDetails.tiers.find((tier: any) => {
            if (!tier.ending_unit) {
                return selectedAttendeeCount >= tier.starting_unit;
            }
            return (
                selectedAttendeeCount >= tier.starting_unit &&
                selectedAttendeeCount <= tier.ending_unit
            );
        });

        if (!tier) {
            return { price: 0, discountedPrice: 0 };
        }

        const basePrice = Math.round(tier.price / 100);
        // Always return the original price, promo discount will only be applied in summary
        return { price: basePrice, discountedPrice: basePrice };
    };

    const updateLeadsquaredActivity = async (email: string | undefined, planId: string | undefined, phoneNumber: string | undefined, flow?: string) => {
        if (!email || !planId) {
            console.error('Email or planId is missing in LS');
            return;
        }

        setIsLoading(true);
        try {
            const LsData = await LeadsquaredService.getLeadsByEmail(email as string);
            const LsId = (LsData as any).ProspectID;
            if (planId === "free-trial-plan") {
                await LeadsquaredService.joinActivity({
                    id: LsId,
                    activityEvent: 205,
                    activityValue: "Free Plan",
                    activityNote: "SSO Authentication"
                });
            } else {
                await LeadsquaredService.joinActivity({
                    id: LsId,
                    activityEvent: 205,
                    activityValue: planId,
                    activityNote: "SSO Authentication"
                });
                LeadsquaredService.joinActivity({
                    id: LsId,
                    activityEvent: 205,
                    activityValue: flow === 'maybe-later' ? "Currently In Trial no cc" : "Currently In Trial",
                    activityNote: "SSO Authentication"
                });
            }
            const leadData = {
                "leadId": LsId,
                "fields": [
                    { "Attribute": "mx_Plan_Name", "Value": planId },
                    { "Attribute": "mx_Status", "Value": "Active" },
                    { "Attribute": "Source", "Value": localStorage.getItem('utm_source') },
                    { "Attribute": "SourceMedium", "Value": localStorage.getItem('utm_medium') },
                    { "Attribute": "SourceCampaign", "Value": localStorage.getItem('utm_campaign') },
                    { "Attribute": "SourceContent", "Value": localStorage.getItem('utm_content') },
                    { "Attribute": "mx_Source_Term", "Value": localStorage.getItem('utm_term') },
                    { "Attribute": "gc_id", "Value": localStorage.getItem('gc_id') },
                    { "Attribute": "h_ga_id", "Value": localStorage.getItem('h_ga_id') },
                    { "Attribute": "h_keyword_id", "Value": localStorage.getItem('h_keyword_id') },
                    { "Attribute": "h_keyword", "Value": localStorage.getItem('h_keyword') },
                    { "Attribute": "h_placement", "Value": localStorage.getItem('h_placement') },
                    { "Attribute": "g_special_campaign", "Value": localStorage.getItem('g_special_campaign') },
                    ...(phoneNumber?.trim() ? [{ "Attribute": "Phone", "Value": phoneNumber }] : [])
                ]
            }
            LeadsquaredService.updateLsField(leadData);
        } catch (error) {
            console.error('Error in LS tags:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleGetStartedSSO = async (flow?: string) => {
        try {
            setIsLoading(true);

            const metadata = decodeMetadataToken();
            const customerId = metadata?.companies?.[0]?.id || ''
            const basePlanId = planDetails?.id
            const couponId = appliedPromo?.code
            const planUnits = flow === 'maybe-later' ? 10 : (parseInt(planId?.match(/-(\d+)$/)?.[1] || '1') || 1)

            // Only process card if it's not "maybe later" flow
            if (flow !== 'maybe-later') {
                // Check if card has any validation errors
                if (cardError) {
                    toast.error('Please fix card validation errors before proceeding');
                    setIsLoading(false);
                    return;
                }

                const result = await cardRef.current.tokenize();

                if (result.error) {
                    setCardError(result.error.message || 'Card tokenization failed');
                    setIsLoading(false);
                    return;
                }

                const cardTokenResult = result.token;
                setCardToken(cardTokenResult);
                setCardError(null);

                if (!cardTokenResult) {
                    setCardError('Please enter valid card details');
                    toast.error('Please enter valid card details');
                    setIsLoading(false);
                    return;
                }

                // Add payment source only if not "maybe later"
                const cardResponse = await chargebeeService.addPaymentSource(customerId, cardTokenResult);

                if (!cardResponse || cardResponse.error) {
                    throw new Error('Failed to add payment source');
                }
            }

            // Create subscription (with or without payment source)
            const subscriptionResponse = await chargebeeService.createSubscription(customerId, basePlanId, couponId, planUnits);

            // Track Google Ads conversion with final amount
            try {
                const priceData = getPlanPrice();
                const conversionValue = isTrial ? 0.0 : priceData.discountedPrice;
                
                // Check if gtag is available (Google Analytics/Ads script loaded)
                if (typeof window !== 'undefined' && (window as any).gtag) {
                    (window as any).gtag('event', 'conversion', {
                        'send_to': 'AW-1030214605/Q5VyCL-xrs4aEM2nn-sD',
                        'value': conversionValue,
                        'currency': 'USD'
                    });
                }
            } catch (conversionError) {
                // Log the error but don't block the flow
                console.error('Google Ads conversion tracking failed:', conversionError);
            }

            // Update Leadsquared activity
            await updateLeadsquaredActivity(formData.email, planId, '', flow);

            await AuthService.refreshToken();
            toast.success('Subscription created successfully');

            // Prepare plan data for tracking
            const priceData = getPlanPrice();
            const purchaseValue = isTrial ? 0.0 : priceData.discountedPrice;
            const userSelection = localStorage.getItem('user_selection');
            const customerType = (userSelection === 'full_access') ? 'with_cc' : 'without_cc';
            
            // Pass plan data through URL parameters
            const planData = {
                price: purchaseValue,
                currency: 'USD',
                coupon: appliedPromo?.code || '',
                plan_name: planDetails?.name || planId || 'Unknown Plan',
                customer_type: customerType
            };

            // Encode plan data as URL parameters
            const planDataParams = new URLSearchParams({
                ...planData,
                price: planData.price.toString()
            }).toString();

            // Clear planId from localStorage before navigation
            localStorage.removeItem('planId');

            // Use window.location.href for full page navigation instead of client-side routing, required for gtm tracking
            window.location.href = `/loading-dashboard?ew_email=${formData.email}&planId=${planId}&companyId=${encodeURIComponent(customerId)}&sso=true&phone=${encodeURIComponent('')}&${planDataParams}`;
        } catch (error: any) {
            console.error('Failed to start trial:', error);

            if (error.message === '409') {
                toast.error('You already have an active subscription. Cannot create duplicate subscription.');
                navigate('/logout');
                return;
            }

            if (error.name === 'INVALID_CARD') {
                setCardError('Please enter valid card details');
            } else {
                toast.error(error.message || 'An error occurred. Please try again.');
            }
            toast.error('Failed to start trial');
        } finally {
            setIsLoading(false);
        }
    };

    const handleGetStarted = async (flow: string) => {
        // If SSO flow is enabled, use the SSO-specific function
        if (isSSOFlow) {
            return handleGetStartedSSO(flow);
        }

        let finalPlanId = planDetails.id

        if(flow === 'maybe-later') {
            finalPlanId = finalPlanId.replace('-Yearly', '-Monthly');
        }

        logEvent(formData.email, EVENT_TYPES.SIGNUP, {
            step: SIGNUP_STEPS.FORM,
            planId: finalPlanId,
            planUnits: selectedAttendeeCount,
            signupFlow: SIGNUP_FLOWS.HOMEPAGE,
            formFlow: flow,
            cardRequired: flow === 'maybe-later' ? false : true
        });

        // Add domain validation here (only for non-SSO flow)
        if (!formData.subdomain.trim()) {
            setFormErrors(prev => ({
                ...prev,
                subdomain: 'Domain is required'
            }));
            setDomainSuggestions([]);
            return;
        } else if (!/^[a-zA-Z0-9-]+$/.test(formData.subdomain)) {
            setFormErrors(prev => ({
                ...prev,
                subdomain: 'Domain can only contain letters, numbers, and hyphens'
            }));
            setDomainSuggestions([]);
            return;
        }

        try {
            setIsLoading(true);

            // Check domain availability first
            const domainResponse = await AuthService.checkSubDomainAvailability(
                formData.subdomain,
                Applications.EASYWEBINAR
            );

            if (!domainResponse.available) {
                setFormErrors(prev => ({
                    ...prev,
                    subdomain: 'This domain is already taken. Please try another one.'
                }));
                // Set domain suggestions if they exist
                if (domainResponse.suggestions && domainResponse.suggestions.length > 0) {
                    setDomainSuggestions(domainResponse.suggestions);
                } else {
                    setDomainSuggestions([]);
                }
                setIsLoading(false);
                return;
            }

            // Clear suggestions if domain is available
            setDomainSuggestions([]);

            let cardTokenResult = null;

            // Only process card if there's a plan and it's not a free trial
            if (planId && !isTrial && flow === 'default') {
                // Check if card has any validation errors
                if (cardError) {
                    toast.error('Please fix card validation errors before proceeding');
                    setIsLoading(false);
                    return;
                }

                const result = await cardRef.current.tokenize();

                if (result.error) {
                    setCardError(result.error.message || 'Card tokenization failed');
                    toast.error('Please check your card details.');
                    setIsLoading(false);
                    return;
                }

                cardTokenResult = result.token;
                setCardToken(cardTokenResult);
                setCardError(null);

                if (!cardTokenResult) {
                    setCardError('Please enter valid card details');
                    toast.error('Please enter valid card details');
                    setIsLoading(false);
                    return;
                }
            }

            // Get UTM parameters directly from URL
            const urlParams = new URLSearchParams(window.location.search);

            const utmParams = {
                utm_source: urlParams.get('utm_source'),
                utm_medium: urlParams.get('utm_medium'),
                utm_campaign: urlParams.get('utm_campaign'),
                utm_content: urlParams.get('utm_content'),
                utm_term: urlParams.get('utm_term'),
                ad_id: urlParams.get('ad_id'),
                fbc_id: urlParams.get('fbc_id'),
                h_ad_id: urlParams.get('h_ad_id'),
                utm_id: urlParams.get('utm_id'),
                gc_id: urlParams.get('gc_id'),
                h_ga_id: urlParams.get('h_ga_id'),
                h_keyword_id: urlParams.get('h_keyword_id'),
                h_keyword: urlParams.get('h_keyword'),
                h_placement: urlParams.get('h_placement'),
                g_special_campaign: urlParams.get('g_special_campaign'),
            };

            // Remove null/undefined values from the UTM params object
            const cleanUtmParams = Object.entries(utmParams)
                .filter(([_, value]) => value !== null && value !== undefined)
                .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});


            // Generate firstName and lastName from email
            const firstName = generateFirstName(formData.email);
            const lastName = "";

            const planUnits = flow === 'maybe-later' ? 10 : (selectedAttendeeCount ?? (parseInt(planId?.match(/-(\d+)$/)?.[1] || '1') || 1));

            const signupData = {
                ...formData,
                firstName,
                lastName,
                phoneNumber: "",
                timezone: getTimezoneString(),
                ...(planId && !isTrial && {
                    planId: finalPlanId,
                    planUnits: planUnits,
                    cardToken: cardTokenResult,
                    couponId: appliedPromo?.code
                }),
                ...(isTrial && {
                    planId: finalPlanId
                }),
                // Include UTM parameters if they exist
                ...(Object.keys(cleanUtmParams).length > 0 && { utm_params: cleanUtmParams })
            };


            const response = await AuthService.signup(signupData);
            setVerificationData({
                companyId: response.data.companyId || '',
                companyName: response.data.companyName || '',
                infLeadSquaredId: response.data.inf_lead_squared_id || ''
            });
            handleVerificationDialogOpen();

            logEvent(formData.email, EVENT_TYPES.SIGNUP, {
                step: SIGNUP_STEPS.VERIFICATION,
                planId: finalPlanId,
                planUnits: planUnits,
                signupFlow: SIGNUP_FLOWS.HOMEPAGE
            });

            // Clear UTM params on successful signup
            clearUtmParamsFromStorage();
            toast.success('Signup successful!');
            
            try {
                await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Waiting To Confirm Email Validation" });
                if (finalPlanId === "free-trial-plan") {
                    await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Free Plan" });
                } else {
                    await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: isTrial ? PLAN_NAMES.FREE_TRIAL : planDetails.id });
                    await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: flow === 'maybe-later' ? "Currently In Trial no cc" : "Currently In Trial" });
                }
            } catch (error: any) {
                console.error('Error joining activities:', error);
            }
        } catch (error: any) {
            console.error('Signup failed:', error);
            setDomainSuggestions([]);
            // Clear UTM params on signup failure too
            clearUtmParamsFromStorage();
            if (error.name === 'INVALID_CARD') {
                setCardError('Please enter valid card details');
                toast.error('Invalid card details. Please try again.');
            } else {
                toast.error(error.message || 'An error occurred during signup. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const validateCoupon = async () => {
        if (!promoCode.trim()) {
            setPromoError('Please enter a promo code');
            toast.error('Please enter a promo code');
            return;
        }

        try {
            const response = await chargebeeService.validateCoupon(
                promoCode,
                planId ? planId.replace(/-\d+$/, '') : undefined
            );

            if (response.data.valid) {
                const { coupon } = response.data;
                setAppliedPromo({
                    code: coupon.id,
                    discount: coupon.discountPercentage || coupon.discountAmount || 0,
                    type: coupon.discountType || 'percentage'
                });
                setPromoError('');
                setShowPromoField(false);
                toast.success('Promo code applied successfully');
            } else {
                setAppliedPromo(null);
                setPromoError('Invalid or inapplicable promo code');
                toast.error('Invalid or inapplicable promo code');
            }
        } catch (error: any) {
            console.error('Coupon validation failed:', error);
            setAppliedPromo(null);
            setPromoError(error?.message || 'Failed to validate promo code');
            toast.error(error?.message || 'Failed to validate promo code');
        }
    };   

    function captureUTMParams() {
        const urlParams = new URLSearchParams(window.location.search);

        const utmSource = urlParams.get('utm_source');
        const utmMedium = urlParams.get('utm_medium');
        const utmCampaign = urlParams.get('utm_campaign');
        const utmContent = urlParams.get('utm_content');
        const utmTerm = urlParams.get('utm_term');
        const email = urlParams.get('email');
        const adId = urlParams.get('ad_id');
        const fbcId = urlParams.get('fbc_id');
        const hAdId = urlParams.get('h_ad_id');
        const utmId = urlParams.get('utm_id');
        const gcId = urlParams.get('gc_id');
        const hGaId = urlParams.get('h_ga_id');
        const hKeywordId = urlParams.get('h_keyword_id');
        const hKeyword = urlParams.get('h_keyword');
        const hPlacement = urlParams.get('h_placement');
        const gSpecialCampaign = urlParams.get('g_special_campaign');

        if (utmSource) localStorage.setItem('utm_source', utmSource);
        if (utmMedium) localStorage.setItem('utm_medium', utmMedium);
        if (utmCampaign) localStorage.setItem('utm_campaign', utmCampaign);
        if (utmContent) localStorage.setItem('utm_content', utmContent);
        if (utmTerm) localStorage.setItem('utm_term', utmTerm);
        if (adId) localStorage.setItem('ad_id', adId);
        if (fbcId) localStorage.setItem('fbc_id', fbcId);
        if (hAdId) localStorage.setItem('h_ad_id', hAdId);
        if (utmId) localStorage.setItem('utm_id', utmId);
        if (gcId) localStorage.setItem('gc_id', gcId);
        if (hGaId) localStorage.setItem('h_ga_id', hGaId);
        if (hKeywordId) localStorage.setItem('h_keyword_id', hKeywordId);
        if (hKeyword) localStorage.setItem('h_keyword', hKeyword);
        if (hPlacement) localStorage.setItem('h_placement', hPlacement);
        if (gSpecialCampaign) localStorage.setItem('g_special_campaign', gSpecialCampaign);
        // Set email from URL parameter if present (only if not already handled by emailFromUrl logic)
        // This ensures we don't override the email if it's being processed by the emailFromUrl flow
        if (email && !emailFromUrl && currentStep === 'signup') {
            setFormData(prev => ({
                ...prev,
                email: email
            }));
        }
    }

    // Add useEffect for capturing UTM parameters
    useEffect(() => {
        console.log("Component mounted, capturing UTM params");
        captureUTMParams();
    }, []);

    const pricing = useMemo(() => {
        return calculateDynamicPricing();
    }, [appliedPromo, isYearly, planDetails, monthlyPlanDetails, planId]);

    // Handle "Maybe later" from features step: set plan units to 10 and proceed
    const handleMaybeLater = async () => {
        try {
            setIsMaybeLaterLoading(true);
            LeadsquaredService.joinActivity({
                id: leadSquaredId,
                activityEvent: 205,
                activityValue: "Limited plan"
            });
            // Mark that user clicked "Limited Access" (without credit card)
            localStorage.setItem('user_selection', 'limited_access');
            await handleGetStarted('maybe-later');
        } catch (e) {
            console.error('Failed to handle Maybe later flow', e);
        } finally {
            setIsMaybeLaterLoading(false);
        }
    };

    return (
        <>
            <Box
                sx={{
                    minHeight: "100vh",
                    width: "100vw",
                    background: `
                linear-gradient(180deg, #010007 26.92%, #AC8DFF 100%),
                linear-gradient(180deg, #FFFFEF 0%, #FFF 100%)
            `,
                    color: "#1f2937",
                    fontFamily: "Inter",
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        p: { xs: "16px 24px", sm: "24px 32px" },
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={LogoDarkMode}
                            alt="logo"
                            style={{ height: 24, cursor: "pointer", maxWidth: "100%" }}
                            onClick={() => window.open("https://easywebinar.com/", "_blank")}
                        />
                    </Box>
                    <Button
                        variant="contained"
                        endIcon={<ArrowForward />}
                        size="small"
                        onClick={() => isSSOFlow ? navigate("/logout") : navigate("/login")}
                        sx={{
                            bgcolor: "#6066E9",
                            color: "#fff",
                            borderRadius: "8px",
                            textTransform: "none",
                            fontWeight: 600,
                            "&:hover": { bgcolor: "#4B4EB5" },
                        }}
                    >
                        {isSSOFlow ? 'Logout' : 'Login'}
                    </Button>
                </Box>


                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: {
                            xs: "calc(100vh - 120px)",
                            sm: "calc(100vh - 100px)",
                            md: "calc(100vh - 80px)",
                        },
                        p: { xs: 1, sm: 2 },
                        pt: { xs: 1, sm: 2, md: 3 },
                    }}
                >
                    {/* Main container with border - responsive sizing */}
                    <Box
                        sx={{
                            width: { xs: "100%", sm: "90%", md: "1200px", lg: "1400px" },
                            maxWidth: { xs: "600px", md: "none" },
                            height: { xs: "auto" },
                            border: "1.5px solid #e5e7eb",
                            borderRadius: "18px",
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            bgcolor: "#ffffff",
                            boxShadow: "0 4px 32px 0 rgba(0,0,0,0.1)",
                            overflow: "hidden",
                        }}
                    >
                        {currentStep === 'signup' && (
                            <>
                                {/* ----------------------------SIGN UP FIRST STEP---------------------------- */}
                                {/* Left side - Promotional Section */}
                                <Box
                                    sx={{
                                        width: "50%",
                                        bgcolor: "#f8fafc",
                                        p: { xs: 3, sm: 4, md: 6 },
                                        display: { xs: "none", md: "flex" },
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        borderRadius: { xs: "18px", md: "18px 0 0 18px" },
                                        minHeight: { xs: "500px", md: "auto" },
                                    }}
                                >
                                     {/* Main heading with statistics */}
                                     <Typography
                                        variant="h3"
                                        sx={{
                                            color: theme.palette.text.primary,
                                            fontSize: { xs: "16px", sm: "18px", md: "20px", lg: "22px" },
                                            textAlign: "center",
                                            mb: 10,
                                            lineHeight: 1.3,
                                        }}
                                    >
                                        EasyWebinar has powered{" "}
                                        <Box component="span" sx={{ fontWeight: 700, }}>
                                            200K+
                                        </Box> <br />
                                        webinars with over{" "}
                                        <Box component="span" sx={{ fontWeight: 700, }}>
                                            69M+
                                        </Box>{" "}
                                        registrations and counting...
                                    </Typography>

                                    {/* Testimonial Block */}
                                    <Box sx={{ mb: 10 }}>
                                        <Stack direction="row" spacing={3} alignItems="center" justifyContent="center" sx={{ maxWidth: 477, margin: "auto" }}>
                                            <Box
                                                component="img"
                                                src={AmyPorterfield}
                                                alt="Amy Porterfield"
                                                sx={{
                                                    width: { xs: 100, sm: 150, md: 180 },
                                                    height: { xs: 100, sm: 150, md: 180 },
                                                    borderRadius: "8px",
                                                    objectFit: "cover",
                                                    flexShrink: 0,
                                                }}
                                            />
                                            <Box sx={{ flex: 1 }}>
                                                <Stack direction="row" spacing={0.5} mb={1}>
                                                    {[...Array(5)].map((_, i) => (
                                                        <StarRoundedIcon key={i} sx={{ color: '#FDBF2F', fontSize: "16px" }} />
                                                    ))}
                                                </Stack>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        color: "#374151",
                                                        fontSize: "16px",
                                                        lineHeight: 1.5,
                                                        mb: 1,
                                                    }}
                                                >
                                                    "I personally use EasyWebinar and they are the best. I moved from using other platforms and nothing compares to their reliability and customer support!"
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: theme.palette.text.secondary,
                                                        fontWeight: 600,
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    Amy Porterfield
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: theme.palette.text.tertiary,
                                                        fontSize: "14px",
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    Online Marketing Expert
                                                </Typography>
                                            </Box>
                                        </Stack>
                                    </Box>

                                    {/* Shield Badges */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 2,
                                            mb: 4,
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        {/* G3 Icons Group Image */}
                                        <Box
                                            component="img"
                                            src="https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g3-icons-3-group.png"
                                            srcSet="
                                                https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g3-icons-3-group.png 1x,
                                                https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g3-icons-3-group-2x.png 2x,
                                                https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g3-icons-3-group-3x.png 3x
                                            "
                                            alt="G3 Icons Group"
                                            sx={{
                                                maxWidth: "100%",
                                                height: "auto",
                                                borderRadius: "8px",
                                            }}
                                        />
                                    </Box>

                                    {/* Company Logos */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: 3,
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={keapWhite}
                                            alt="keap"
                                            sx={{
                                                filter: "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)",
                                                opacity: 0.5,
                                            }}
                                        />
                                        <Box
                                            component="img"
                                            src={teachableWhite}
                                            alt="teachable"
                                            sx={{
                                                filter: "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)",
                                                opacity: 0.5,
                                            }}
                                        />
                                        <Box
                                            component="img"
                                            src={foundrWhite}
                                            alt="foundr"
                                            sx={{
                                                filter: "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)",
                                                opacity: 0.5,
                                            }}
                                        />
                                        <Box
                                            component="img"
                                            src={clientPointWhite}
                                            alt="clientPoint"
                                            sx={{
                                                filter: "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)",
                                                opacity: 0.5,
                                            }}
                                        />
                                    </Box>
                                </Box>

                                {/* Right side - Form Section */}
                                <Box
                                    sx={{
                                        width: { xs: "100%", md: "50%" },
                                        bgcolor: "#ffffff",
                                        p: { xs: 3, sm: 4, md: 6 },
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        borderRadius: { xs: "18px", md: "0 18px 18px 0" },
                                        minHeight: { xs: "500px", md: "auto" },
                                    }}
                                >
                                    <Box sx={{ position: "relative", textAlign: 'center' }}>
                                        <Typography
                                            color="#333333"
                                            fontWeight="700"
                                            fontSize={{ xs: "24px", xl: "30px" }}
                                            lineHeight="normal"
                                            mb="8px"
                                            display="inline-block"
                                            textAlign="center"
                                            sx={{ position: "relative" }}
                                        >
                                            Create your free account
                                        </Typography>
                                    </Box>
                                    <Box display="flex" gap="12px" mb="24px" flexWrap="wrap" justifyContent="center" alignItems="center">
                                        {!isTrial ? (
                                            <>
                                                <Typography
                                                    color="#666666"
                                                    fontSize="14px"
                                                >
                                                    Set up in minutes
                                                </Typography>
                                                <Box borderRadius="50%" width="4px" height="4px" sx={{ background: "#666" }}></Box>
                                                <Typography
                                                    color="#666666"
                                                    fontSize="14px"
                                                >
                                                    Cancel anytime
                                                </Typography>
                                            </>
                                        ) : (
                                            <Typography
                                                color="#666666"
                                                fontSize="14px"
                                            >
                                                No Credit Card Required
                                            </Typography>
                                        )}
                                    </Box>

                                    <Box sx={{ width: '100%' }} className="umbrella-signIn-tabs">
                                        <Box sx={{ display: "flex", justifyContent: "center", height: "4px" }}>
                                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                                {/* <Tab {...a11yProps(0)} sx={{
                                                    '& .MuiButtonBase-root.MuiTab-root.Mui-selected': {
                                                        color: '#178EFC !important',
                                                    },
                                                    '&.MuiTabs-indicator': {
                                                        backgroundColor: '#178EFC !important',
                                                    },
                                                }} />
                                                <Tab {...a11yProps(1)} disabled={value !== 1} /> */}
                                            </Tabs>
                                        </Box>
                                        <Box sx={{ width: "100%", my:1 }}>
                                            <Box
                                                sx={{
                                                    minHeight: "4px",
                                                    backgroundColor: "#178EFC !important",
                                                    borderRadius: "20px",
                                                    width: "60px",
                                                    mx: "auto",
                                                    mb: 3,
                                                    pt: '0 !important'
                                                }}
                                            />
                                            </Box>
                                        <CustomTabPanel value={value} index={0}>
                                            {/* -----------commented below code as per the requirement---------- */}
                                            {/* <Box width="100%" textAlign="center" mb="24px">
                                                <Box display="flex" mb="14px" justifyContent="center" flexWrap="wrap" gap="12px">
                                                    <Box height={{ xs: "38px", sm: "42px" }} minWidth={{ xs: "fit-content", sm: "138px" }} px={{ xs: "12px", sm: "20px" }} borderRadius="4px" display="flex" alignItems="center" justifyContent="center" border="1px solid #D0D5DD" sx={{ cursor: "pointer", "&:hover": { bgcolor: "#f7f7f7" } }} onClick={handleGoogleSignIn}>
                                                        <Box mr={{ xs: "8px" }} display="flex"><GoogleIcon /></Box>
                                                        <Typography variant="body1" color="#0C141D">Google</Typography>
                                                    </Box>
                                                    <Box height={{ xs: "38px", sm: "42px" }} minWidth={{ xs: "fit-content", sm: "138px" }} px={{ xs: "12px", sm: "20px" }} borderRadius="4px" display="flex" alignItems="center" justifyContent="center" border="1px solid #D0D5DD" sx={{ cursor: "pointer", "&:hover": { bgcolor: "#f7f7f7" } }} onClick={handleLinkedinSignIn}>
                                                        <Box mr={{ xs: "8px" }} display="flex"><LinkedInsmallIcon /></Box>
                                                        <Typography variant="body1" color="#0C141D">Linkedin</Typography>
                                                    </Box> */}
                                                    {/* <Box height={{ xs: "38px", sm: "42px" }} minWidth={{ xs: "fit-content", sm: "138px" }} px={{ xs: "12px", sm: "20px" }} borderRadius="2.747px" display="flex" alignItems="center" justifyContent="center" border="1px solid #D0D5DD" sx={{ cursor: "pointer", "&:hover": { bgcolor: "#f7f7f7" } }}>
                            <Box mr={{ xs: "8px" }}><MicrosoftIcon /></Box>
                            <Typography variant="body1" color="#0C141D">Microsoft</Typography>
                        </Box> */}
                                                {/* </Box>
                                                <Box borderBottom="1px solid #D9D9D9" height="1px" position="relative" width={{ xs: "100%", sm: "76%" }} margin="24px auto 27px" > <Typography variant="body2" color="#667085" bgcolor="#ffffff" position="absolute" left="50%" sx={{ transform: "translate(-50%, -50%)" }} p="0 6px" whiteSpace="nowrap">Or  continue with email</Typography></Box>
                                            </Box> */}
                                            {/* -----------commented below code as per the requirement---------- */}

                                            <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }} mb={{ xs: "24px", sm: "48px" }}>
                                                <Grid size={{ xs: 12 }}>
                                                    <TextField
                                                        variant="outlined"
                                                        label="Work email"
                                                        name="email"
                                                        placeholder="you@company.com"
                                                        value={formData.email}
                                                        onChange={handleInputChange}
                                                        error={!!formErrors.email}
                                                        helperText={formErrors.email}
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: '8px',
                                                                borderColor: '#666666',
                                                            },

                                                            " .MuiInputLabel-root.Mui-focused": {
                                                                color: "inherit",
                                                            },

                                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: '#333333',
                                                                border: '1px solid'
                                                            },

                                                            "& .MuiOutlinedInput-input": {
                                                                padding: '14px 16px',
                                                                background: '#ffffff',
                                                                borderRadius: '8px'
                                                            },
                                                            "&.MuiInputBase-input::placeholder": {
                                                                color: '#333333',
                                                                fontSize: '16px',
                                                                opacity: '0.8'
                                                            },
                                                        }}
                                                        fullWidth
                                                    />
                                                </Grid>
                                                {/* Commented out firstName field - will be generated from email
                                        <Grid size={{ xs: 12, sm: 6 }}>
                                            <TextField
                                                variant="outlined"
                                                label="First name"
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleInputChange}
                                                error={!!formErrors.firstName}
                                                helperText={formErrors.firstName}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: '3px',
                                                        borderColor: '#666666',
                                                    },

                                                    " .MuiInputLabel-root.Mui-focused": {
                                                        color: "inherit",
                                                    },

                                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: '#333333',
                                                        border: '1px solid'
                                                    },

                                                    "& .MuiOutlinedInput-input": {
                                                        padding: '14px 16px',
                                                        background: '#ffffff',
                                                        borderRadius: '8px'
                                                    },
                                                    "&.MuiInputBase-input::placeholder": {
                                                        color: '#333333',
                                                        fontSize: '16px',
                                                        opacity: '0.8'
                                                    },
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        */}
                                                {/* Commented out lastName field - will be empty
                                        <Grid size={{ xs: 12, sm: 6 }}>
                                            <TextField
                                                variant="outlined"
                                                label="Last name"
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleInputChange}
                                                error={!!formErrors.lastName}
                                                helperText={formErrors.lastName}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: '3px',
                                                        borderColor: '#666666',
                                                    },

                                                    " .MuiInputLabel-root.Mui-focused": {
                                                        color: "inherit",
                                                    },

                                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: '#333333',
                                                        border: '1px solid'
                                                    },

                                                    "& .MuiOutlinedInput-input": {
                                                        padding: '14px 16px',
                                                        background: '#ffffff',
                                                        borderRadius: '8px'
                                                    },
                                                    "&.MuiInputBase-input::placeholder": {
                                                        color: '#333333',
                                                        fontSize: '16px',
                                                        opacity: '0.8'
                                                    },
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        */}
                                                {/* Commented out phone field - not required
                                        <Grid size={{ xs: 12 }}>
                                            <MuiPhone
                                                value=""
                                                onChange={() => {}}
                                                onBlur={() => {}}
                                                error={false}
                                                helperText=""
                                                fullWidth
                                            />
                                        </Grid>
                                        */}
                                                {/* Password field commented out - will auto-generate strong password */}
                                                {/* <Grid size={{ xs: 12 }}>
                                                    <TextField
                                                        variant="outlined"
                                                        label="Password"
                                                        type={showPassword ? 'text' : 'password'}
                                                        name="password"
                                                        value={formData.password}
                                                        onChange={handleInputChange}
                                                        error={!!passwordError}
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: '8px',
                                                                borderColor: '#666666',
                                                                background: '#ffffff',
                                                                paddingRight: '0'
                                                            },

                                                            " .MuiInputLabel-root.Mui-focused": {
                                                                color: "inherit",
                                                            },

                                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: '#333333',
                                                                border: '1px solid'
                                                            },

                                                            "& .MuiOutlinedInput-input": {
                                                                padding: '14px 16px',
                                                                background: '#ffffff',
                                                                borderRadius: '8px'
                                                            },
                                                            "&.MuiInputBase-input::placeholder": {
                                                                color: '#333333',
                                                                fontSize: '16px',
                                                                opacity: '0.8'
                                                            },
                                                        }}
                                                        slotProps={{
                                                            input: {
                                                                endAdornment: <InputAdornment position="start"><IconButton onClick={handleClickShowPassword}
                                                                    sx={{ borderRadius: "2px", "&:hover": { backgroundColor: "unset" } }}
                                                                    onMouseDown={handleMouseDownPassword}
                                                                    onMouseUp={handleMouseUpPassword}  >
                                                                    {!showPassword ? <Box display="flex" gap="4px" alignItems="center" color="#000000"><VisibilityIcon fontSize='small' />
                                                                        <Typography component="span" color="#000000" fontSize="14px">Show</Typography></Box>
                                                                        : <Box display="flex" gap="4px" alignItems="center" color="#000000">
                                                                            <VisibilityOffIcon fontSize='small'></VisibilityOffIcon> <Typography component="span" fontSize="14px">hide</Typography></Box>
                                                                    }
                                                                </IconButton>
                                                                </InputAdornment>
                                                            },
                                                        }}
                                                        fullWidth
                                                    />
                                                    <PasswordStrengthIndicator password={formData.password} />
                                                </Grid> */}
                                            </Grid>
                                            <Button
                                                variant="contained"
                                                disableElevation
                                                disabled={isLoading}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    textTransform: "unset",
                                                    width: "100%",
                                                    height: "48px",
                                                    gap: "8px",
                                                    fontSize: "16px",
                                                    fontWeight: "500",
                                                    margin: "auto",
                                                    bgcolor: "#4058FB !important",
                                                    "&:hover": { bgcolor: "#2E3FD9 !important" },
                                                    "&.Mui-disabled": {
                                                        bgcolor: "#178EFC !important",
                                                        opacity: 0.7
                                                    }
                                                }}
                                                onClick={handleNext}
                                            >
                                                {isLoading ? (
                                                    <CircularProgress size={24} sx={{ color: 'white' }} />
                                                ) : (
                                                    'Continue'
                                                )}
                                            </Button>
                                            <Box
                                                sx={{
                                                    textAlign: 'center',
                                                    mt: 2,
                                                    mb: 2
                                                }}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: '#374151',
                                                        fontSize: '14px',
                                                        fontWeight: 400,
                                                        lineHeight: 1.5,
                                                    }}
                                                >
                                                    100% Free Trial • Cancel Anytime • No Hidden Fees
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: '#374151',
                                                        fontSize: '10px',
                                                        fontWeight: 400,
                                                        lineHeight: 1.5,
                                                        mt: 2,
                                                    }}
                                                >
                                                    By starting your trial, you agree to our <a href="https://easywebinar.com/terms-conditions/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Terms of Service</a> and <a href="https://easywebinar.com/privacy/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Privacy Policy</a>
                                                </Typography>
                                            </Box>
                                        </CustomTabPanel>
                                    </Box>
                                </Box >
                            </>
                        )}

                        {/* ----------------------------SIGN UP SECOND STEP---------------------------- */}
                        {/* Webinar Type Selection Step */}
                        {currentStep === 'webinar-type' && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: '100%',
                                    minHeight: '70vh',
                                    p: { xs: 3, md: 6 },
                                    pt: { xs: "80px", md: 6 },
                                    position: 'relative'
                                }}
                            >
                                {/* Back Button - Hidden in SSO Flow */}
                                {!isSSOFlow && (
                                    <Button
                                        variant="text"
                                        startIcon={<ChevronLeft />}
                                        onClick={() => setCurrentStep('signup')}
                                        sx={{
                                            position: 'absolute',
                                            top: { xs: 8, md: 24 },
                                            left: { xs: 16, md: 24 },
                                            color: theme.palette.text.secondary + ' !important',
                                            textTransform: 'none',
                                            boxShadow: 'none !important',
                                            '&:hover': {
                                                backgroundColor: 'rgba(107, 114, 128, 0.04)',
                                                boxShadow: 'none !important'
                                            }
                                        }}
                                    >
                                        Back
                                    </Button>
                                )}

                                <Box
                                    sx={{

                                        textAlign: 'center'
                                    }}
                                >
                                    {/* Header */}
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            color: '#1f2937',
                                            fontWeight: 600,
                                            fontSize: { xs: '24px', md: '32px' },
                                            mb: "44px",
                                            lineHeight: 1.2
                                        }}
                                    >
                                        What capabilities do you want in your webinar plan?
                                    </Typography>

                                    {/* <Typography
                                        variant="body1"
                                        sx={{
                                            color: '#6b7280',
                                            fontSize: { xs: '14px', md: '16px' },
                                            mb: "44px",
                                            lineHeight: 1.5
                                        }}
                                    >
                                        Pick any plan to begin — you can switch anytime later
                                    </Typography> */}

                                    <Box maxWidth="570px" width="100%" margin="0 auto">
                                        {/* Webinar Type Options */}
                                        <Box
                                            sx={{
                                                display: 'grid',
                                                gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
                                                gap: { xs: 2, md: "20px"},
                                                mb: { xs: "30px", md: "50px" }
                                            }}
                                        >
                                            {/* Live Webinar Option */}
                                            <Box
                                                onClick={() => setSelectedWebinarType('live')}
                                                sx={{
                                                    border: selectedWebinarType === 'live' ? '2px solid #8B5CF6' : '2px solid #e5e7eb',
                                                    borderRadius: '12px',
                                                    p: { xs: "16px", md: "18px 10px" },
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease-in-out',
                                                    background: selectedWebinarType === 'live' ? '#f3f0ff' : '#ffffff',
                                                    minHeight: '120px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    '&:hover': {
                                                        borderColor: '#8B5CF6',
                                                    }
                                                }}
                                            >
                                                <Typography
                                                    variant="h6"
                                                    sx={{
                                                        color: selectedWebinarType === 'live' ? '#1f2937' : '#6b7280',
                                                        fontWeight: 600,
                                                        fontSize: '18px',
                                                        mb: 1,
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    Live
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: '#6b7280',
                                                        fontSize: '11px',
                                                        lineHeight: 1.4,
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    For hosting real-time sessions to teach, demo, or engage live.
                                                </Typography>
                                            </Box>

                                            {/* Automated Webinars Option */}
                                            {/* <Box
                                                onClick={() => setSelectedWebinarType('automated')}
                                                sx={{
                                                    border: selectedWebinarType === 'automated' ? '2px solid #8B5CF6' : '2px solid #e5e7eb',
                                                    borderRadius: '12px',
                                                    p: { xs: "16px", md: "18px 10px" },
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease-in-out',
                                                    background: selectedWebinarType === 'automated' ? '#f3f0ff' : '#ffffff',
                                                    minHeight: '120px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    position: 'relative',
                                                    '&:hover': {
                                                        borderColor: '#8B5CF6',
                                                    }
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        top: -10,
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        backgroundColor: '#000000',
                                                        color: '#ffffff',
                                                        padding: '4px 12px',
                                                        borderRadius: '12px',
                                                        fontSize: '10px',
                                                        fontWeight: 600,
                                                        whiteSpace: 'nowrap',
                                                        zIndex: 2
                                                    }}
                                                >
                                                    Ideal for Growth
                                                </Box>
                                                <Typography
                                                    variant="h6"
                                                    sx={{
                                                        color: selectedWebinarType === 'automated' ? '#1f2937' : '#6b7280',
                                                        fontWeight: 600,
                                                        fontSize: '18px',
                                                        mb: 1,
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    Automated Webinars
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: '#6b7280',
                                                        fontSize: '11px',
                                                        lineHeight: 1.4,
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    Run pre-recorded, live-like sessions with chat and evergreen tools to generate leads, demos, and sales 24/7.
                                                </Typography>
                                            </Box> */}

                                            {/* Live + Automated Option */}
                                            <Box
                                                onClick={() => setSelectedWebinarType('live-automated')}
                                                sx={{
                                                    border: selectedWebinarType === 'live-automated' ? '2px solid #8B5CF6' : '2px solid #e5e7eb',
                                                    borderRadius: '12px',
                                                    p: { xs: "16px", md: "18px 10px" },
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease-in-out',
                                                    background: selectedWebinarType === 'live-automated' ? '#f3f0ff' : '#ffffff',
                                                    minHeight: '120px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    position: 'relative',
                                                    '&:hover': {
                                                        borderColor: '#8B5CF6',
                                                    }
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        top: -10,
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        backgroundColor: '#8B5CF6',
                                                        color: '#ffffff',
                                                        padding: '4px 12px',
                                                        borderRadius: '12px',
                                                        fontSize: '10px',
                                                        fontWeight: 600,
                                                        whiteSpace: 'nowrap',
                                                        zIndex: 2
                                                    }}
                                                >
                                                    Most Popular
                                                </Box>
                                                <Typography
                                                    variant="h6"
                                                    sx={{
                                                        color: selectedWebinarType === 'live-automated' ? '#1f2937' : '#6b7280',
                                                        fontWeight: 600,
                                                        fontSize: '18px',
                                                        mb: 1,
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    Live + Automated
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: '#6b7280',
                                                        fontSize: '11px',
                                                        lineHeight: 1.4,
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    For going live and scaling with SimuLive + automated evergreen webinars.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* Next Button */}
                                        <Button
                                            variant="contained"
                                            disableElevation
                                            sx={{
                                                backgroundColor: '#4058FB',
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textTransform: "unset",
                                                width: "100%",
                                                height: "48px",
                                                maxWidth: "450px",
                                                margin: "auto",
                                                '&:hover': {
                                                    backgroundColor: '#2E3FD9'
                                                }
                                            }}
                                            onClick={handleWebinarTypeSelection}
                                        >
                                            Next
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        )}

                        {/* Full Offer Table Step */}
                        {currentStep === 'full-offer-table' && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: '100%',
                                    minHeight: '70vh',
                                    p: { xs: 2, md: 6 },
                                    pt: { xs: "51px", md: 6 },
                                    position: 'relative',
                                    backgroundColor: '#ffffff'
                                }}
                            >
                                {/* Back Button */}
                                <Button
                                    variant="text"
                                    startIcon={<ChevronLeft />}
                                    onClick={() => setCurrentStep('webinar-type')}
                                    sx={{
                                        position: 'absolute',
                                        top: { xs: 8, md: 24 },
                                        left: { xs: 16, md: 24 },
                                        color: theme.palette.text.secondary + ' !important',
                                        textTransform: 'none',
                                        boxShadow: 'none !important',
                                        '&:hover': {
                                            backgroundColor: 'rgba(107, 114, 128, 0.04)',
                                            boxShadow: 'none !important'
                                        }
                                    }}
                                >
                                    Back
                                </Button>

                                {/* Main Card */}
                                <Box
                                    sx={{
                                        backgroundColor: '#ffffff',
                                        borderRadius: { xs: '12px', sm: '16px' },
                                        p: { xs: 3, sm: 4, md: 5 },
                                        maxWidth: { xs: '100%', sm: '600px' },
                                        width: '100%',
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                        position: 'relative'
                                    }}
                                >
                                    {/* Title */}
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            color: '#1f2937',
                                            fontWeight: 700,
                                            fontSize: { xs: '20px', sm: '24px', md: '28px' },
                                            mb: { xs: 3, sm: 4 },
                                            lineHeight: 1.2,
                                            textAlign: 'center'
                                        }}
                                    >
                                        Choose Your Access Level
                                    </Typography>

                                    {/* Full Access Trial Option */}
                                    <Box
                                        sx={{
                                            backgroundColor: '#000000',
                                            borderRadius: { xs: '10px', sm: '12px' },
                                            p: { xs: 2.5, sm: 3 },
                                            mb: 3,
                                            textAlign: 'center'
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: '#ffffff',
                                                fontWeight: 700,
                                                fontSize: { xs: '18px', sm: '20px' },
                                                mb: 1,
                                                textAlign: 'center'
                                            }}
                                        >
                                            Full Access Trial
                                        </Typography>
                                        <Typography
                                            sx={{
                                                color: '#ffffff',
                                                fontSize: { xs: '14px', sm: '16px' },
                                                mb: 2.5,
                                                opacity: 0.9,
                                                textAlign: 'center'
                                            }}
                                        >
                                            Unlock all limits. Free for 7 days.
                                        </Typography>
                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Button
                                                variant="contained"
                                                disableElevation
                                                endIcon={<ArrowForward />}
                                                onClick={handleFullOfferTableSelection}
                                                disabled={isMaybeLaterLoading}
                                                sx={{
                                                    backgroundColor: '#4058FB',
                                                    color: '#ffffff',
                                                    height: { xs: '44px', sm: '48px' },
                                                    borderRadius: { xs: '8px', sm: '10px' },
                                                    fontSize: { xs: '14px', sm: '16px' },
                                                    fontWeight: 600,
                                                    textTransform: 'none',
                                                    width: { xs: '85%', sm: '50%' },
                                                    maxWidth: '400px',
                                                    '&:hover': {
                                                        backgroundColor: '#2E3FD9'
                                                    },
                                                    '&:disabled': {
                                                        backgroundColor: '#4058FB',
                                                        opacity: 0.6
                                                    }
                                                }}
                                            >
                                                Start Free Trial
                                            </Button>
                                        </Box>
                                    </Box>

                                    {/* Separator */}
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            mb: 3
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                flex: 1,
                                                height: '1px',
                                                backgroundColor: '#e5e7eb'
                                            }}
                                        />
                                        <Typography
                                            sx={{
                                                color: '#9ca3af',
                                                fontSize: { xs: '13px', sm: '14px' },
                                                px: 2
                                            }}
                                        >
                                            or
                                        </Typography>
                                        <Box
                                            sx={{
                                                flex: 1,
                                                height: '1px',
                                                backgroundColor: '#e5e7eb'
                                            }}
                                        />
                                    </Box>

                                    {/* Limited Access Option */}
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Typography
                                            sx={{
                                                color: '#1f2937',
                                                fontWeight: 700,
                                                fontSize: { xs: '18px', sm: '20px' },
                                                mb: 1,
                                                textAlign: 'center'
                                            }}
                                        >
                                            Limited Access
                                        </Typography>
                                        <Typography
                                            sx={{
                                                color: '#6b7280',
                                                fontSize: { xs: '14px', sm: '16px' },
                                                mb: 2.5,
                                                textAlign: 'center'
                                            }}
                                        >
                                            Use the free plan with basic limits.
                                        </Typography>
                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Button
                                                variant="outlined"
                                                endIcon={<ArrowForward />}
                                                onClick={handleMaybeLater}
                                                disabled={isMaybeLaterLoading}
                                                sx={{
                                                    borderColor: '#000000',
                                                    color: '#1f2937',
                                                    height: { xs: '44px', sm: '48px' },
                                                    borderRadius: { xs: '8px', sm: '10px' },
                                                    fontSize: { xs: '14px', sm: '16px' },
                                                    fontWeight: 600,
                                                    textTransform: 'none',
                                                    width: { xs: '85%', sm: '50%' },
                                                    maxWidth: '400px',
                                                    backgroundColor: '#ffffff',
                                                    '&:hover': {
                                                        borderColor: '#000000',
                                                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                                    },
                                                    '&:disabled': {
                                                        borderColor: '#000000',
                                                        opacity: 0.5
                                                    }
                                                }}
                                            >
                                                {isMaybeLaterLoading ? (
                                                    <CircularProgress size={20} sx={{ color: '#1f2937' }} />
                                                ) : (
                                                    'Continue'
                                                )}
                                            </Button>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        )}

                        {/* Attendee Count Step */}
                        {currentStep === 'attendee-count' && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: '100%',
                                    minHeight: '70vh',
                                    p: { xs: 3, md: 6 },
                                    pt: { xs: "80px", md: 6 },
                                    position: 'relative'
                                }}
                            >
                                {/* Back Button */}
                                <Button
                                    variant="text"
                                    startIcon={<ChevronLeft />}
                                    onClick={() => setCurrentStep('full-offer-table')}
                                    sx={{
                                        position: 'absolute',
                                        top: { xs: 8, md: 24 },
                                        left: { xs: 16, md: 24 },
                                        color: theme.palette.text.secondary + ' !important',
                                        textTransform: 'none',
                                        boxShadow: 'none !important',
                                        '&:hover': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.05)',
                                            boxShadow: 'none !important'
                                        }
                                    }}
                                >
                                    Back
                                </Button>

                                <Box
                                    sx={{
                                        backgroundColor: '#ffffff',
                                        borderRadius: '16px',
                                        p: { xs: 3, md: 5 },
                                        maxWidth: '480px',
                                        width: '100%',
                                        boxShadow: '0 8px 18px -6px rgba(19, 25, 39, 0.12), 0 12px 42px -4px rgba(19, 25, 39, 0.12)'
                                    }}
                                >
                                    {/* Main Content */}
                                    <Box sx={{
                                        textAlign: 'center'
                                    }}>
                                        {/* Heading */}
                                        <Typography
                                            variant="h4"
                                            sx={{
                                                fontSize: { xs: '20px', sm: '24px', md: '32px' },
                                                fontWeight: 700,
                                                color: '#1f2937',
                                                mb: 3,
                                                lineHeight: 1.2
                                            }}
                                        >
                                            We're thrilled to have you  try the full platform!
                                        </Typography>

                                        {/* Question */}
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                fontSize: { xs: '14px', sm: '16px' },
                                                color: '#6b7280',
                                                mb: 3,
                                                fontWeight: 500
                                            }}
                                        >
                                            How many attendees are you expecting?{' '}
                                            {selectedWebinarType === 'live-automated' && <Tooltip title="Professional Plan supports both live and automated webinars. Each live attendee capacity comes with five times automated attendees." arrow>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="#6b7280"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    style={{ verticalAlign: 'middle', marginLeft: 4, cursor: 'pointer' }}
                                                >
                                                    <circle cx="12" cy="12" r="10" />
                                                    <line x1="12" y1="16" x2="12" y2="12" />
                                                    <line x1="12" y1="8" x2="12" y2="8" />
                                                </svg>
                                            </Tooltip>}
                                        </Typography>

                                        {/* Segmented Control for Attendee Selection */}
                                        <Box sx={{ mb: selectedWebinarType === 'live-automated' ? 2 : 4 }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    backgroundColor: '#ffffff',
                                                    borderRadius: '8px',
                                                    border: '1px solid #e5e7eb',
                                                    padding: '4px',
                                                    gap: '1px',
                                                    overflow: 'auto'
                                                }}
                                            >
                                                {attendeeCountOptions.map((option, index) => (
                                                    <Box
                                                        key={option}
                                                        onClick={() => handleAttendeeSelection(option)}
                                                        sx={{
                                                            flex: 1,
                                                            padding: '8px 16px',
                                                            borderRadius: '6px',
                                                            textAlign: 'center',
                                                            cursor: 'pointer',
                                                            transition: 'all 0.2s ease-in-out',
                                                            backgroundColor: selectedAttendeeCount === option ? '#374151' : 'transparent',
                                                            color: selectedAttendeeCount === option ? '#ffffff' : '#6b7280',
                                                            fontSize: { xs: '14px', lg: '16px' },
                                                            fontWeight: 500,
                                                            '&:hover': {
                                                                backgroundColor: selectedAttendeeCount === option ? '#374151' : '#f3f4f6',
                                                                color: selectedAttendeeCount === option ? '#ffffff' : '#374151'
                                                            }
                                                        }}
                                                    >
                                                        {option}
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Box>

                                        {/* Live & Automated Attendees Count Display - Only for Live+Automated webinar type */}
                                        {selectedWebinarType === 'live-automated' && selectedAttendeeCount && (
                                            <Box sx={{ mb: 4, textAlign: 'center' }}>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        fontSize: { xs: '14px', },
                                                        color: '#6b7280',
                                                        fontWeight: 500,
                                                        lineHeight: 1.4
                                                    }}
                                                >
                                                    <Box component="span" sx={{ color: '#4CAF50', fontWeight: 600 }}>
                                                        {selectedAttendeeCount.toLocaleString()}
                                                    </Box>
                                                    <Box component="span" sx={{ color: '#6b7280', fontWeight: 500 }}>
                                                        {' Live & '}
                                                    </Box>
                                                    <Box component="span" sx={{ color: '#4CAF50', fontWeight: 600 }}>
                                                        {(selectedAttendeeCount * 5).toLocaleString()}
                                                    </Box>
                                                    <Box component="span" sx={{ color: '#6b7280', fontWeight: 500 }}>
                                                        {' Automated Attendees'}
                                                    </Box>
                                                </Typography>
                                            </Box>
                                        )}

                                        {/* Commented out dropdown for reference */}
                                        {/* 
                                        <Box sx={{ mb: 4 }}>
                                            <TextField
                                                select
                                                value={selectedAttendeeCount ?? ''}
                                                onChange={(e) => setSelectedAttendeeCount(Number(e.target.value))}
                                                variant="outlined"
                                                fullWidth
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        backgroundColor: '#ffffff',
                                                        borderRadius: '12px',
                                                        fontSize: { xs: '14px', sm: '16px' },
                                                        fontWeight: 500,
                                                        color: '#1f2937',
                                                        '&:hover': {
                                                            borderColor: '#9ca3af'
                                                        },
                                                        '&.Mui-focused': {
                                                            borderColor: '#4058FB',
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: '#4058FB'
                                                            }
                                                        },
                                                        '& .MuiSelect-select': {
                                                            padding: '12px 20px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }
                                                    },
                                                    '& .MuiSelect-icon': {
                                                        color: '#6b7280',
                                                        fontSize: '20px'
                                                    }
                                                }}
                                            >
                                                {attendeeCountOptions.map((option) => (
                                                    <MenuItem
                                                        key={option}
                                                        value={option}
                                                        sx={{
                                                            fontSize: { xs: '14px', sm: '16px' },
                                                            fontWeight: 500,
                                                            color: '#1f2937',
                                                            padding: '12px 20px',
                                                            justifyContent: 'center',
                                                            '&:hover': {
                                                                backgroundColor: '#f3f4f6'
                                                            },
                                                            '&.Mui-selected': {
                                                                backgroundColor: '#4058FB',
                                                                color: '#ffffff',
                                                                '&:hover': {
                                                                    backgroundColor: '#4058FB'
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        {`${option} attendees`}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Box>
                                        */}
                                    </Box>

                                    {/* Next Button */}
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        disableElevation
                                        sx={{
                                            backgroundColor: '#4058FB',
                                            color: '#ffffff',
                                            height: '48px',
                                            borderRadius: '12px',
                                            fontSize: { xs: '14px', sm: '16px' },
                                            fontWeight: 600,
                                            textTransform: 'none',
                                            '&:hover': {
                                                backgroundColor: '#2E3FD9'
                                            }
                                        }}
                                        onClick={handleAttendeeCountSelection}
                                    >
                                        Next
                                    </Button>
                                </Box>
                            </Box>
                        )}
                        {/* type of webinars */}

                        {currentStep === 'payment-method' && (

                            <>
                                {/* ----------------------------SIGN UP FIRST STEP---------------------------- */}
                                {/* Left side - Promotional Section */}
                                <Box
                                    sx={{
                                        width: "50%",
                                        bgcolor: "#f8fafc",
                                        p: { xs: 3, sm: 4, md: 6 },
                                        display: { xs: "none", md: "flex" },
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        borderRadius: { xs: "18px", md: "18px 0 0 18px" },
                                        minHeight: { xs: "500px", md: "auto" },
                                        position: 'relative'
                                    }}
                                >
                                    {/* Back Button */}
                                    <Button
                                        variant="text"
                                        startIcon={<ChevronLeft />}
                                        onClick={() => setCurrentStep('attendee-count')}
                                        sx={{
                                            position: 'absolute',
                                            top: { xs: 8, md: 24 },
                                            left: { xs: 16, md: 24 },
                                            color: theme.palette.text.secondary + ' !important',
                                            textTransform: 'none',
                                            boxShadow: 'none !important',
                                            '&:hover': {
                                                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                                                boxShadow: 'none !important'
                                            }
                                        }}
                                    >
                                        Back
                                    </Button>
                                    <Box sx={{ textAlign: 'left' }}
                                        margin="auto">
                                        {/* How it works title */}
                                        <Typography
                                            variant="h4"
                                            sx={{
                                                color: '#1f2937',
                                                fontSize: { xs: '20px', sm: '24px', md: '28px' },
                                                fontWeight: 700,
                                                mb: '44px',
                                                textAlign: 'center'
                                            }}
                                        >
                                            How it works
                                        </Typography>

                                        {/* Today section */}
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: { xs: "24px", md: "32px", lg: "34px" } }} position="relative">
                                            <Box mr={1.5} sx={{ position: 'relative' }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none">
                                                    <path d="M0 18.293C0 8.62799 7.83502 0.792969 17.5 0.792969C27.165 0.792969 35 8.62799 35 18.293C35 27.958 27.165 35.793 17.5 35.793C7.83502 35.793 0 27.958 0 18.293Z" fill="#7F8FFC" />
                                                    <path d="M0 18.293C0 8.62799 7.83502 0.792969 17.5 0.792969C27.165 0.792969 35 8.62799 35 18.293C35 27.958 27.165 35.793 17.5 35.793C7.83502 35.793 0 27.958 0 18.293Z" fill="white" fill-opacity="0.81" />
                                                    <path d="M8.44939 15.5846C9.05203 15.6581 9.68066 15.6163 10.287 15.6102C10.9037 15.604 11.5204 15.5984 12.1371 15.5917C13.379 15.5781 14.6209 15.5725 15.8627 15.5575C18.3249 15.5278 20.7871 15.5185 23.2488 15.4618C23.9465 15.4457 24.6444 15.4386 25.3421 15.4233C26.0398 15.4081 26.7739 15.4488 27.4618 15.3268C27.683 15.2876 27.8206 15.0303 27.7897 14.8246C27.7535 14.5843 27.5732 14.4531 27.3401 14.4277C27.0489 14.396 26.7554 14.4205 26.463 14.4295C26.1428 14.4394 25.8227 14.4485 25.5025 14.4569C24.8859 14.4732 24.2691 14.487 23.6524 14.4989C22.4109 14.5229 21.1684 14.5206 19.9267 14.5322C17.4645 14.5552 15.0025 14.5561 12.5407 14.6118C11.8427 14.6275 11.145 14.6466 10.4474 14.6732C9.75247 14.6997 9.03106 14.694 8.34651 14.8247C8.15985 14.8603 8.04296 15.0733 8.0694 15.2492C8.10026 15.4541 8.25243 15.5606 8.44939 15.5846Z" fill="#1A1818" />
                                                    <path d="M11.5843 9.91308C11.0492 9.87775 10.5342 9.84377 9.99702 9.87192C9.52882 9.89648 9.04687 9.97429 8.66462 10.2654C8.25381 10.5783 8.08567 11.0498 8.03183 11.5478C7.97462 12.0768 8.01165 12.6221 8.01336 13.1534C8.02091 15.4969 8.05906 17.8402 8.082 20.1837C8.09338 21.3485 8.10677 22.5133 8.11795 23.6781C8.12887 24.8162 8.10861 25.9607 8.15686 27.0978C8.17812 27.5987 8.27675 28.1082 8.62855 28.4878C8.96384 28.8496 9.44342 28.9885 9.91711 29.0475C10.3996 29.1075 10.8923 29.0968 11.3777 29.1073C11.8981 29.1185 12.4187 29.1269 12.9393 29.1326C14.1024 29.1455 15.2657 29.1487 16.4289 29.1426C17.6866 29.1359 18.9537 29.1718 20.2097 29.1112C20.7979 29.0828 20.8 28.2214 20.2097 28.1957C19.1551 28.1497 18.092 28.1918 17.0363 28.1961C16.0397 28.2002 15.0431 28.2064 14.0465 28.2055C13.0692 28.2045 12.0917 28.1977 11.1146 28.1763C10.6911 28.167 10.2437 28.1913 9.82766 28.1023C9.49792 28.0318 9.23324 27.8932 9.13549 27.5488C9.01213 27.1143 9.05971 26.6207 9.05221 26.1741C9.04286 25.6194 9.03548 25.0647 9.02606 24.5101C9.00721 23.4008 8.98815 22.2915 8.97009 21.1821C8.93415 18.9775 8.91146 16.7721 8.865 14.5678C8.85187 13.9437 8.83761 13.3198 8.82284 12.6958C8.81158 12.2194 8.71446 11.6286 8.90445 11.1744C9.06538 10.7897 9.50005 10.6905 9.87687 10.6658C10.1451 10.6482 10.4145 10.6541 10.6825 10.6355C10.9853 10.6146 11.2831 10.5611 11.5844 10.5256C11.9699 10.4802 11.9858 9.9396 11.5843 9.91308Z" fill="#1A1818" />
                                                    <path d="M11.8484 10.4872C12.0706 9.99499 11.9814 9.41958 12.0625 8.89893C12.0672 8.86857 12.1123 8.80668 12.071 8.83308C12.0218 8.86444 12.1028 8.84663 12.1148 8.84872C12.23 8.86882 12.3678 8.85118 12.4852 8.85331C12.6276 8.85589 12.7699 8.85848 12.9123 8.86106C12.977 8.86223 13.0417 8.86319 13.1064 8.86457C13.1323 8.86502 13.1582 8.86552 13.1841 8.86598C13.2594 8.87049 13.2576 8.86857 13.1788 8.86014C13.1488 8.80852 13.1186 8.75689 13.0886 8.7053C13.135 8.83396 13.1083 9.03046 13.1115 9.17154C13.1154 9.34289 13.1197 9.51421 13.1236 9.68552C13.1314 10.031 13.1428 10.3766 13.1463 10.7221C13.1498 11.0529 13.145 11.3845 13.1221 11.7146C13.1063 11.943 13.0958 12.0729 12.8694 12.1293C12.6654 12.1802 12.4389 12.1634 12.2324 12.1341C12.1685 12.125 12.0001 12.1172 11.9652 12.0574C11.9348 12.0054 11.9761 11.7917 11.9802 11.7184C12.0215 10.9702 12.0886 10.2199 12.0582 9.47246C12.0399 9.02333 11.405 9.03329 11.3675 9.47246C11.3225 9.99941 11.3326 10.523 11.3381 11.0529C11.3408 11.3025 11.3448 11.552 11.346 11.8016C11.347 12.0371 11.3237 12.2698 11.4869 12.4626C11.7156 12.7327 12.1211 12.7577 12.4512 12.7706C12.7671 12.783 13.1427 12.7817 13.4133 12.5956C13.794 12.3338 13.7971 11.8223 13.8254 11.4075C13.8583 10.9256 13.8675 10.44 13.8514 9.95734C13.8436 9.72205 13.8339 9.48685 13.8249 9.25161C13.8159 9.01599 13.8442 8.74338 13.7655 8.51877C13.5972 8.03902 12.9176 8.16638 12.5241 8.16417C12.2849 8.16284 12.0209 8.12969 11.7931 8.21643C11.5412 8.31234 11.4169 8.5367 11.3868 8.79392C11.3562 9.05444 11.3611 9.32713 11.3692 9.58906C11.3779 9.86601 11.3582 10.1721 11.4539 10.4357C11.5101 10.5905 11.765 10.6719 11.8484 10.4872Z" fill="#1A1818" />
                                                    <path d="M22.2117 10.4448C22.294 10.0452 22.3151 9.65273 22.3244 9.24609C22.3285 9.06714 22.2996 8.85037 22.3378 8.67589C22.3279 8.72084 22.2834 8.68473 22.3659 8.69415C22.4503 8.70379 22.5421 8.69157 22.6271 8.69207C22.8352 8.69324 23.0433 8.70658 23.2513 8.7153C23.3439 8.71918 23.5698 8.68465 23.6443 8.74178C23.641 8.73932 23.6398 8.87181 23.6394 8.9294C23.639 9.02127 23.6387 9.11314 23.6384 9.20501C23.6356 10.1469 23.6724 11.0981 23.6206 12.0388C23.5915 12.5653 24.4058 12.5618 24.4383 12.0388C24.4932 11.1543 24.4504 10.2629 24.4228 9.37828C24.4079 8.90071 24.4865 8.25816 23.9309 8.0619C23.6246 7.95373 23.256 8.01749 22.9391 8.03046C22.6349 8.04289 22.2415 7.96962 21.9656 8.12642C21.5999 8.3341 21.6733 8.81342 21.6792 9.16468C21.6864 9.5991 21.7008 10.0175 21.786 10.4448C21.8281 10.6561 22.1685 10.6547 22.2117 10.4448Z" fill="#1A1818" />
                                                    <path d="M23.8349 9.64194C23.7782 10.0545 23.6976 10.4653 23.6851 10.882C23.6726 11.2995 23.6856 11.7165 23.6581 12.1338C23.78 12.0119 23.902 11.8899 24.0239 11.7681C23.7239 11.7857 23.427 11.8297 23.1261 11.8379C22.8747 11.8447 22.5498 11.8867 22.3055 11.8149C22.3545 11.8293 22.3148 11.922 22.3379 11.8046C22.3435 11.776 22.3372 11.7357 22.3376 11.7067C22.3387 11.6306 22.3377 11.551 22.348 11.4755C22.3729 11.2921 22.3741 11.0776 22.3747 10.8775C22.3759 10.4263 22.3792 9.97497 22.3753 9.52379C22.3735 9.32383 22.3719 9.12387 22.371 8.9239C22.3702 8.741 22.3845 8.55334 22.336 8.37535C22.2481 8.0532 21.7866 8.06388 21.6935 8.37535C21.6369 8.56464 21.6544 8.77373 21.6534 8.96957C21.6522 9.20873 21.6505 9.44794 21.6518 9.68706C21.6546 10.1849 21.6628 10.6828 21.6663 11.1807C21.6676 11.3774 21.7007 11.544 21.6989 11.7407C21.696 12.0434 21.7734 12.3109 22.0832 12.4254C22.366 12.5298 22.7178 12.5101 23.0155 12.5128C23.35 12.5158 23.6904 12.5275 24.0238 12.4994C24.2272 12.4823 24.381 12.3455 24.3895 12.1337C24.406 11.7293 24.4024 11.3211 24.3845 10.9168C24.3664 10.5072 24.2762 10.1099 24.2636 9.69994C24.2564 9.46662 23.8697 9.38814 23.8349 9.64194Z" fill="#1A1818" />
                                                    <path d="M13.4549 10.5928C13.8282 10.705 14.2661 10.6864 14.6542 10.6947C14.9987 10.7021 15.3438 10.6984 15.6884 10.6985C16.3673 10.6988 17.0462 10.6846 17.7251 10.6862C19.1418 10.6895 20.558 10.6513 21.9741 10.611C22.4905 10.5963 22.4908 9.78572 21.9741 9.80791C20.5583 9.86867 19.1419 9.91158 17.7251 9.93727C17.0585 9.94936 16.3907 9.93347 15.7242 9.92105C15.3675 9.91442 15.0108 9.90103 14.6542 9.89678C14.2635 9.89215 13.8355 9.85878 13.4549 9.95503C13.1307 10.037 13.15 10.5011 13.4549 10.5928Z" fill="#1A1818" />
                                                    <path d="M13.9772 21.5322C14.0918 21.4004 14.2233 21.2618 14.3962 21.2377C14.6218 21.2063 14.8193 21.3787 14.9815 21.5386C15.3729 21.9245 15.7644 22.3104 16.1558 22.6963C16.3121 22.8503 16.5116 23.0172 16.7242 22.963C16.8582 22.9289 16.9539 22.8145 17.0402 22.7065C18.4469 20.9444 19.8535 19.1823 21.2602 17.4203C21.7588 17.7321 22.2171 18.108 22.6206 18.5357C22.7477 18.6704 22.8756 18.8246 22.8884 19.0094C22.9035 19.228 22.7546 19.4201 22.614 19.5882C20.938 21.5923 19.2619 23.5963 17.5858 25.6003C17.4219 25.7964 17.2335 26.0064 16.9801 26.0391C16.7376 26.0704 16.5097 25.9293 16.3075 25.7917C15.4018 25.1753 14.5303 24.5086 13.6983 23.7959C13.3886 23.5307 12.9017 23.2399 13.0433 22.7701C13.1783 22.3217 13.6765 21.8779 13.9772 21.5322Z" fill="#1A1818" />
                                                    <path d="M16.2576 22.3816C15.8733 21.7776 15.164 21.4489 14.718 20.8941C14.5945 20.7405 14.3319 20.7677 14.2043 20.8941C13.6384 21.4549 13.0949 22.035 12.55 22.6161C12.4299 22.7442 12.3968 22.9937 12.55 23.1167C13.7256 24.0608 14.9112 24.993 16.0849 25.9395C16.3611 26.1622 16.6593 26.4998 17.0443 26.4803C17.4944 26.4575 17.8224 25.9474 18.0926 25.6416C18.7021 24.9518 19.2704 24.23 19.8326 23.5017C20.145 23.0969 20.4574 22.692 20.7776 22.2933C21.1148 21.8736 21.483 21.4811 21.8225 21.0636C22.0441 20.7911 21.6985 20.4261 21.4309 20.672C20.7944 21.2568 20.2435 21.9546 19.6898 22.6173C19.139 23.2763 18.5993 23.9448 18.0424 24.5986C17.7619 24.9278 17.4751 25.2517 17.1789 25.5669C17.1229 25.6264 17.0681 25.691 17.0054 25.7441C16.9466 25.794 16.9996 25.739 17.0235 25.75C16.9977 25.7381 16.9713 25.7187 16.9484 25.7019C16.822 25.6091 16.7049 25.4998 16.5832 25.4006C16.0263 24.9467 15.4604 24.5044 14.8917 24.0654C14.2746 23.589 13.6429 23.1235 13.0506 22.616C13.0506 22.7829 13.0506 22.9498 13.0506 23.1166C13.6138 22.5532 14.1759 21.9914 14.718 21.4077C14.5468 21.4077 14.3756 21.4077 14.2043 21.4077C14.656 21.9242 15.2871 22.278 15.792 22.7408C16.0311 22.9601 16.4457 22.6772 16.2576 22.3816Z" fill="#1A1818" />
                                                    <path d="M14.3353 21.2028C14.4677 21.7016 14.8683 22.0859 15.2411 22.4213C15.6301 22.7713 16.0422 23.1002 16.4856 23.3789C16.6275 23.4681 16.8731 23.4506 16.9854 23.3144C17.7611 22.3728 18.5312 21.4264 19.3122 20.4891C20.0894 19.5565 20.8604 18.5927 21.7328 17.7467C21.5734 17.7672 21.414 17.7878 21.2547 17.8083C21.8448 18.1894 22.3936 18.6857 22.8328 19.2336C22.8328 19.0215 22.8328 18.8096 22.8328 18.5975C22.0212 19.5348 21.2302 20.4933 20.4534 21.4595C20.0817 21.9218 19.7239 22.3958 19.3658 22.8686C18.968 23.3939 18.5584 23.9124 18.1942 24.4616C17.9763 24.7902 18.4807 25.1858 18.7442 24.886C19.1794 24.391 19.5775 23.8642 19.9951 23.3542C20.3547 22.9152 20.7224 22.483 21.0834 22.0453C21.8656 21.0969 22.6766 20.1734 23.4688 19.2335C23.6354 19.0358 23.6374 18.7965 23.4688 18.5975C22.9732 18.0128 22.3457 17.4618 21.6529 17.127C21.5085 17.0572 21.2885 17.0475 21.1749 17.1887C20.4118 18.137 19.5544 19.0137 18.7545 19.9314C17.9532 20.8507 17.1733 21.7864 16.4021 22.7311C16.5687 22.7096 16.7353 22.6881 16.9019 22.6666C16.5062 22.4204 16.1285 22.1423 15.7723 21.8419C15.4102 21.5366 15.0699 21.1868 14.6524 20.959C14.4879 20.8694 14.286 21.0175 14.3353 21.2028Z" fill="#1A1818" />
                                                    <path d="M27.2346 12.1156C27.2068 12.3492 27.1648 12.5808 27.1454 12.8152C27.1261 13.0477 27.1336 13.2823 27.1332 13.5155C27.1326 13.9829 27.1374 14.4503 27.1347 14.9176C27.1292 15.8677 27.1133 16.8177 27.1103 17.7679C27.1042 19.6417 27.1264 21.5154 27.1223 23.3894C27.1203 24.3379 27.1143 25.2863 27.1007 26.2347C27.0951 26.6237 27.1213 27.0326 27.0604 27.4178C27.0122 27.7229 26.8828 27.9718 26.5838 28.0902C26.3029 28.2014 25.9775 28.2084 25.6769 28.2161C25.2469 28.2271 24.8168 28.2341 24.3867 28.2398C23.5282 28.2512 22.6695 28.2499 21.8109 28.2432C20.8344 28.2357 19.858 28.2191 18.8814 28.2089C17.838 28.198 16.7828 28.1453 15.7406 28.1979C15.1513 28.2276 15.1516 29.0808 15.7406 29.1134C16.6922 29.166 17.6531 29.1374 18.6063 29.1492C19.5221 29.1606 20.4379 29.1692 21.3537 29.174C22.2386 29.1786 23.1235 29.1779 24.0083 29.1693C24.4631 29.1649 24.918 29.1587 25.3726 29.1463C25.7613 29.1356 26.1527 29.1283 26.5352 29.0497C26.9166 28.9714 27.2996 28.794 27.554 28.4912C27.8365 28.1548 27.9398 27.7433 27.9754 27.3136C28.0118 26.8744 27.9956 26.428 27.9976 25.9876C27.9997 25.493 28.0003 24.9984 27.9999 24.5037C27.9983 22.5623 27.9925 20.6185 27.9629 18.6774C27.9463 17.5892 27.9282 16.5011 27.9149 15.4129C27.9081 14.8627 27.9124 14.3128 27.9181 13.7627C27.9208 13.5021 27.9312 13.2405 27.9276 12.9799C27.9236 12.6903 27.8737 12.4035 27.847 12.1155C27.8103 11.7182 27.2809 11.726 27.2346 12.1156Z" fill="#1A1818" />
                                                    <path d="M23.9617 10.4957C24.2977 10.5949 24.6698 10.5645 25.0182 10.5692C25.3397 10.5734 25.669 10.5624 25.9889 10.5984C26.4873 10.6546 26.8156 10.9074 26.9465 11.3907C27.0934 11.9327 27.0619 12.5257 27.0719 13.0821C27.0777 13.4013 27.0821 13.7207 27.088 14.0399C27.0948 14.4089 27.088 14.7781 27.1959 15.1328C27.2906 15.4441 27.7626 15.4646 27.8478 15.1328C27.9459 14.7508 27.9268 14.3588 27.9298 13.9661C27.9325 13.5958 27.9361 13.2254 27.9353 12.855C27.9339 12.22 27.9675 11.5309 27.7412 10.9258C27.4795 10.226 26.922 9.84771 26.1889 9.76727C25.8399 9.72899 25.4858 9.74066 25.1353 9.74388C24.7505 9.74742 24.3321 9.71026 23.9617 9.82023C23.6294 9.91894 23.6282 10.3973 23.9617 10.4957Z" fill="#1A1818" />
                                                </svg>
                                            </Box>
                                            {/* Connector line */}
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    left: "16px",
                                                    top: '39px',
                                                    width: '2px',
                                                    height: { xs: '32px', md: '100%' },
                                                    background: 'repeating-linear-gradient(to bottom, #808185 0px, #000000 4px, transparent 4px, transparent 8px)',
                                                    transform: 'translateX(-50%)',
                                                    zIndex: 1
                                                }}
                                            />
                                            <Box>
                                                <Typography
                                                    variant="h6"
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '18px',
                                                        fontWeight: 700,
                                                        mb: 0.5,
                                                    }}
                                                >
                                                    Today
                                                </Typography>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        color: '#7C7D7E',
                                                        fontSize: {xs: '16px', xl: '18px'},
                                                        lineHeight: 1.5,
                                                    }}
                                                >
                                                    All features are now available. Experience the full power.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* Day 6 section */}
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: { xs: "24px", md: "32px", lg: "34px" } }} position='relative'>
                                            <Box mr={1.5}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                                                    <path d="M0 16.9297C0 8.09313 7.16344 0.929688 16 0.929688C24.8366 0.929688 32 8.09313 32 16.9297C32 25.7662 24.8366 32.9297 16 32.9297C7.16344 32.9297 0 25.7662 0 16.9297Z" fill="#7F8FFC" />
                                                    <path d="M0 16.9297C0 8.09313 7.16344 0.929688 16 0.929688C24.8366 0.929688 32 8.09313 32 16.9297C32 25.7662 24.8366 32.9297 16 32.9297C7.16344 32.9297 0 25.7662 0 16.9297Z" fill="white" fill-opacity="0.81" />
                                                    <path d="M17.9083 24.9883C17.9083 26.0416 17.0544 26.8955 16.001 26.8955C14.9477 26.8955 14.0938 26.0416 14.0938 24.9883" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M14.1684 8.43727C14.1198 8.269 14.0938 8.09118 14.0938 7.90726C14.0938 6.85391 14.9477 6 16.001 6C17.0544 6 17.9083 6.85391 17.9083 7.90726C17.9083 8.03893 17.8949 8.16749 17.8695 8.29165" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M22.1904 16.7839C22.7709 11.4865 19.9976 8.34766 16.0261 8.34766C16.0169 8.34766 16.0079 8.348 15.9987 8.348C15.9896 8.34795 15.9806 8.34766 15.9714 8.34766C11.9999 8.34766 9.22657 11.4865 9.80704 16.7839C10.0864 19.3332 9.42145 21.367 8.71414 22.7368C8.24782 23.6399 8.89917 24.7161 9.91554 24.7161H22.0819C23.0983 24.7161 23.7496 23.6399 23.2833 22.7368C22.576 21.367 21.911 19.3332 22.1904 16.7839Z" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M9.23633 21.543H18.7934" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M22.3008 8.82812C22.737 8.82812 23.1732 8.99451 23.506 9.32733C23.8388 9.66015 24.0052 10.0964 24.0052 10.5325" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M22.3008 6.83594C23.2472 6.83594 24.1937 7.19699 24.9158 7.91915C25.6379 8.6413 25.999 9.58773 25.999 10.5342" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M9.7005 8.82812C9.26429 8.82812 8.82808 8.99451 8.4953 9.32733C8.16253 9.66015 7.99609 10.0964 7.99609 10.5325" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M9.69825 6.83594C8.75179 6.83594 7.80532 7.19699 7.08321 7.91915C6.3611 8.6413 6 9.58773 6 10.5342" stroke="#262424" stroke-width="0.938361" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </Box>
                                            {/* Connector line */}
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    left: "16px",
                                                    top: '39px',
                                                    width: '2px',
                                                    height: { xs: '32px', md: '100%' },
                                                    background: 'repeating-linear-gradient(to bottom, #808185 0px, #000000 4px, transparent 4px, transparent 8px)',
                                                    transform: 'translateX(-50%)',
                                                    zIndex: 1
                                                }}
                                            />
                                            <Box>
                                                <Typography
                                                    variant="h6"
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '18px',
                                                        fontWeight: 700,
                                                        mb: 0.5,
                                                    }}
                                                >
                                                    Day 6
                                                </Typography>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        color: '#7C7D7E',
                                                        fontSize: {xs: '16px', xl: '18px'},
                                                        lineHeight: 1.5,
                                                    }}
                                                >
                                                    We'll remind you 1 day before your free access ends.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* After Day 7 section */}
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <Box mr={1.5}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none">
                                                    <path d="M0 15.0664C0 6.78214 6.71573 0.0664062 15 0.0664062C23.2843 0.0664062 30 6.78214 30 15.0664C30 23.3507 23.2843 30.0664 15 30.0664C6.71573 30.0664 0 23.3507 0 15.0664Z" fill="#7F8FFC" />
                                                    <path d="M0 15.0664C0 6.78214 6.71573 0.0664062 15 0.0664062C23.2843 0.0664062 30 6.78214 30 15.0664C30 23.3507 23.2843 30.0664 15 30.0664C6.71573 30.0664 0 23.3507 0 15.0664Z" fill="white" fill-opacity="0.81" />
                                                    <mask id="mask0_15479_32349" mask-type="luminance" maskUnits="userSpaceOnUse" x="5" y="5" width="20" height="20">
                                                        <path d="M24.9854 5.01465V24.9854H5.01465V5.01465H24.9854Z" fill="white" stroke="white" stroke-width="0.0292969" />
                                                    </mask>
                                                    <g mask="url(#mask0_15479_32349)">
                                                        <path d="M18.8671 12.3799L13.6259 17.6211L11.1309 15.1261" stroke="#3C3737" stroke-width="1.5625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                        <mask id="mask1_15479_32349" mask-type="luminance" maskUnits="userSpaceOnUse" x="5" y="5" width="20" height="20">
                                                            <path d="M24.9805 24.9805V5.01953H5.01953V24.9805H24.9805Z" fill="white" stroke="white" stroke-width="0.0390625" />
                                                        </mask>
                                                        <g mask="url(#mask1_15479_32349)">
                                                            <path d="M24.2148 15C24.2148 20.0914 20.0875 24.2188 14.9961 24.2188C9.90473 24.2188 5.77734 20.0914 5.77734 15C5.77734 9.90864 9.90473 5.78125 14.9961 5.78125C20.0875 5.78125 24.2148 9.90864 24.2148 15Z" stroke="#3C3737" stroke-width="1.5625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                    </g>
                                                </svg>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    variant="h6"
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '18px',
                                                        fontWeight: 700,
                                                        mb: 0.5,
                                                    }}
                                                >
                                                    After Day 7
                                                </Typography>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        color: '#7C7D7E',
                                                        fontSize: {xs: '16px', xl: '18px'},
                                                        lineHeight: 1.5,
                                                    }}
                                                >
                                                    Your subscription begins unless you cancel beforehand.
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Divider */}
                                    <Box
                                        sx={{
                                            width: '70%',
                                            height: '3px',
                                            background: 'linear-gradient(to right, transparent 0%, rgba(0, 0, 0, 0.2) 20%, rgba(0, 0, 0, 0.2) 80%, transparent 100%)',
                                            opacity: 0.2,
                                            my: 5,
                                            mx: 'auto'
                                        }}
                                    />

                                    {/* G2 Badges Section */}
                                    <Box
                                        sx={{
                                            textAlign: 'center',
                                            pb: 4,
                                            px: 2,
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                color: '#000000',
                                                fontSize: { xs: '18px', md: '18px', xl: '20px'},
                                                lineHeight: 1.4,
                                                mb: 3,
                                                textAlign: 'center',
                                                maxWidth: '500px',
                                                mx: 'auto'
                                            }}
                                        >
                                            Recognized by customers across the world as a leader in multiple categories on G2
                                        </Typography>
                                        
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                flexWrap: { xs: 'wrap', md: 'nowrap' },
                                                gap: { xs: 2, md: 3 },
                                                maxWidth: '100%',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            <img
                                                src="https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5.png"
                                                srcSet="
                                                    https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5.png 1x,
                                                    https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5-2x.png 2x,
                                                    https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5-3x.png 3x
                                                "
                                                alt="G2 Badges - High Performer, Users Love Us, High Performer Asia Pacific, Leader Small Business, Momentum Leader"
                                                style={{
                                                    maxWidth: '500px',
                                                    height: 'auto',
                                                }}
                                            />
                                        </Box>
                                    </Box>

                                    
                                </Box>

                                {/* Right side - Form Section */}
                                <Box
                                    sx={{
                                        width: { xs: "100%", md: "50%" },
                                        bgcolor: "#ffffff",
                                        p: { xs: "71px 16px 24px 16px", sm: 4, md: 6, lg: "104px 40px" },
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        borderRadius: { xs: "18px", md: "0 18px 18px 0" },
                                        minHeight: { xs: "500px", md: "auto" },
                                        position: 'relative'
                                    }}
                                >
                                    <Button
                                        variant="text"
                                        startIcon={<ChevronLeft />}
                                        onClick={() => setCurrentStep('full-offer-table')}
                                        sx={{
                                            position: 'absolute',
                                            top: { xs: 8, md: 24 },
                                            left: { xs: 16, md: 24 },
                                            color: theme.palette.text.secondary + ' !important',
                                            textTransform: 'none',
                                            boxShadow: 'none !important',
                                            display: {xs: "flex", md: "none"},
                                            '&:hover': {
                                                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                                                boxShadow: 'none !important'
                                            }
                                        }}
                                    >
                                        Back
                                    </Button>
                                    <>
                                        <Box sx={{ position: "relative", textAlign: 'center' }} mb="40px">
                                            <Typography
                                                color="#333333"
                                                fontWeight="700"
                                                fontSize={{ xs: "24px", md: "28px" }}
                                                lineHeight="normal"
                                                mb="8px"
                                                display="block"
                                                textAlign="center"
                                            >
                                                7 days free with full access.
                                            </Typography>
                                            <Typography
                                                color="#71757D"
                                                fontWeight="600"
                                                fontSize={{ xs: "14px", xl: "16px" }}
                                                lineHeight="normal"
                                                display="block"
                                                textAlign="center"
                                            >
                                                No strings attached. Cancel anytime.
                                            </Typography>
                                            {/* <Typography
                                                color="#71757D"
                                                fontWeight="600"
                                                fontSize={{ xs: "14px", xl: "16px" }}
                                                lineHeight="normal"
                                                display="block"
                                                textAlign="center"
                                            >
                                                {(() => {
                                                    const priceText = isYearly ? pricing.yearlyPrice : pricing.monthlyPrice;
                                                    const originalPriceText = isYearly ? pricing.originalYearlyPrice : pricing.originalMonthlyPrice;
                                                    
                                                    if (appliedPromo && originalPriceText !== priceText) {
                                                        return (
                                                            <>
                                                                Then <span style={{ textDecoration: 'line-through', color: '#999999' }}>{originalPriceText}</span> {priceText} per month{isYearly ? ' (billed yearly)' : ''} after the trial ends.
                                                            </>
                                                        );
                                                    } else {
                                                        return `Then ${priceText} per month${isYearly ? ' (billed yearly)' : ''} after the trial ends.`;
                                                    }
                                                })()}
                                            </Typography> */}
                                        </Box>
                                    </>

                                    <Box sx={{ display: "flex", justifyContent: "center", mb: 4, mt: { xs: 1, sm: 0 } }}>
                                        {/* Billing Period Toggle Switch */}
                                        <Box
                                            sx={{
                                                position: "relative",
                                                width: "185px",
                                                height: "42px",
                                                bgcolor: "#F5F5F5",
                                                borderRadius: "21px",
                                                cursor: "pointer",
                                                overflow: "visible",
                                            }}
                                            onClick={() => handleBillingPeriodChange(!isYearly)}
                                        >
                                            {/* Sliding Thumb */}
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: "3px",
                                                    left: isYearly ? "3px" : "49%", // 50px = 185px - 132px (thumb width) - 3px (margin)
                                                    width: "50%",
                                                    height: "36px",
                                                    bgcolor: "#000000",
                                                    borderRadius: "18px",
                                                    transition: "left 0.3s ease",
                                                    zIndex: 1,
                                                }}
                                            />
                                            
                                            {/* Yearly Option */}
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: "0",
                                                    left: "0",
                                                    width: "92.5px",
                                                    height: "42px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    zIndex: 2,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: isYearly ? "#ffffff" : "#1F2937",
                                                        fontSize: "15px",
                                                        fontWeight: 600,
                                                        textAlign: "center",
                                                        zIndex: 3,
                                                    }}
                                                >
                                                    Yearly
                                                </Typography>
                                                
                                                {/* Save Badge - Only show when yearly is selected */}
                                                
                                                    <Box
                                                        sx={{
                                                            position: "absolute",
                                                            bottom: "-14px",
                                                            bgcolor: "#3AF833",
                                                            color: "#131927",
                                                            fontSize: "11px",
                                                            fontWeight: 500,
                                                            px: "8px",
                                                            py: "4px",
                                                            borderRadius: "12px",
                                                            whiteSpace: "nowrap",
                                                            zIndex: 4,
                                                        }}
                                                    >
                                                        {isYearly ? `Saving ${calculateDynamicPricing().savings}` : `Save ${calculateDynamicPricing().savings}`}
                                                    </Box>
                                            </Box>
                                            
                                            {/* Monthly Option */}
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: "0",
                                                    right: "0",
                                                    width: "92.5px",
                                                    height: "42px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    zIndex: 2,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: isYearly ? "#1F2937" : "#ffffff",
                                                        fontSize: "15px",
                                                        fontWeight: 600,
                                                        textAlign: "center",
                                                        zIndex: 3,
                                                    }}
                                                >
                                                    Monthly
                                                </Typography>
                                            </Box>
                                        </Box>

                                    </Box>

                                    <Box display="flex" justifyContent="space-between" marginBottom="12px" borderBottom="1px dashed #A3A3A33D" paddingBottom="8px">
                                        <Typography color="#2B2B30" fontSize="16px" fontWeight={700}>
                                            {planDetails?.externalName} plan
                                        </Typography>
                                        <Box textAlign="right">
                                            <Box display="flex" alignItems="center" gap={1} justifyContent="flex-end">
                                                {isYearly && (
                                                    <Typography 
                                                        color="#666666" 
                                                        fontSize="16px" 
                                                        fontWeight={700}
                                                        sx={{ textDecoration: 'line-through' }}
                                                    >
                                                        {calculateDynamicPricing().monthlyPrice}
                                                    </Typography>
                                                )}
                                                <Typography color="#22B060" fontSize="16px" fontWeight={700}>
                                                {isYearly ? calculateDynamicPricing().yearlyPrice : calculateDynamicPricing().monthlyPrice}/month
                                                </Typography>
                                            </Box>
                                            <Typography color="#A3A3A3" fontSize="16px">
                                                ({isYearly ? 'Yearly' : 'Monthly'} billing)
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {/* Attendees Selection */}
                                    <Box sx={{ width: '100%', mb: 3 }}>
                                        <Typography 
                                            sx={{ 
                                                color: '#9292A0', 
                                                fontSize: '15px', 
                                                fontWeight: 500, 
                                                textAlign: 'center',
                                                mb: 1.5,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            Attendees  {selectedWebinarType === 'live-automated' && <Tooltip title="Professional Plan supports both live and automated webinars. Each live attendee capacity comes with five times automated attendees." arrow>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="#6b7280"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    style={{ verticalAlign: 'middle', marginLeft: 4, cursor: 'pointer' }}
                                                >
                                                    <circle cx="12" cy="12" r="10" />
                                                    <line x1="12" y1="16" x2="12" y2="12" />
                                                    <line x1="12" y1="8" x2="12" y2="8" />
                                                </svg>
                                            </Tooltip>}
                                        </Typography>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                bgcolor: '#f5f5f5',
                                                borderRadius: '8px',
                                                p: '4px',
                                                maxWidth: '400px',
                                                mx: 'auto',
                                                overflow: "auto"
                                            }}
                                        >
                                            {attendeeCountOptions.map((attendees) => (
                                                <Box
                                                    key={attendees}
                                                    onClick={() => handleAttendeeSelection(attendees)}
                                                    sx={{
                                                        flex: 1,
                                                        textAlign: 'center',
                                                        py: '8px',
                                                        px: '12px',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        bgcolor: selectedAttendeeCount === attendees ? '#374151' : 'transparent',
                                                        color: selectedAttendeeCount === attendees ? '#ffffff' : '#6b7280',
                                                        fontWeight: selectedAttendeeCount === attendees ? 600 : 500,
                                                        fontSize: '14px',
                                                        '&:hover': {
                                                            bgcolor: selectedAttendeeCount === attendees ? '#374151' : '#e5e7eb',
                                                            color: selectedAttendeeCount === attendees ? '#ffffff' : '#374151'
                                                        }
                                                    }}
                                                >
                                                    {attendees}
                                                </Box>
                                            ))}
                                        </Box>

                                         {selectedWebinarType === 'live-automated' && selectedAttendeeCount && (
                                             <Typography color="#9292A0" fontSize="14px" fontWeight={500} textAlign="center" mt="8px">
                                                 <span style={{ color: '#22B060', fontWeight: 600 }}>{selectedAttendeeCount.toLocaleString()}</span> Live & <span style={{ color: '#22B060', fontWeight: 600 }}>{(selectedAttendeeCount * 5).toLocaleString()}</span> Automated Attendees
                                             </Typography>
                                         )}
                                    </Box>

                                    <Box sx={{ width: '100%' }} className="umbrella-signIn-tabs">
                                        <Box width="100%" mb="8px">
                                            <Typography color="#333333" fontSize="14px" fontWeight="500" mb="12px">
                                                Card Details
                                            </Typography>
                                            <Box width="100%" sx={{
                                                position: "relative",
                                                "& .CbHosted": {
                                                    borderRadius: '3px',
                                                    border: '1px solid rgba(0, 0, 0, 0.23)',
                                                    padding: '14px 16px',
                                                    "&:hover, &--focus": {
                                                        borderColor: '#666666',
                                                    }
                                                }
                                            }}>
                                                <CardComponent
                                                    ref={cardRef}
                                                    currency="USD"
                                                    showTestCards={true}
                                                    styles={{
                                                        border: "1px solid #666666",
                                                        base: {
                                                            padding: "14px 16px",
                                                            border: "1px solid #666666",
                                                            fontSize: '16px',
                                                            fontFamily: 'Inter, sans-serif',
                                                            color: '#333333',
                                                            '::placeholder': {
                                                                color: '#667085',
                                                            },
                                                        },
                                                        invalid: {
                                                            color: '#ff0000',
                                                        },
                                                    }}
                                                    onChange={(status: any) => {
                                                        console.log('Card status:', status);

                                                        if (status.error) {
                                                            setCardError(status.error.message);
                                                            setIsCardValid(false);
                                                        } else if (!status.complete) {
                                                            // Clear error but indicate card is not complete
                                                            setCardError(null);
                                                            setIsCardValid(false);
                                                        } else {
                                                            // Card is complete and valid
                                                            setCardError(null);
                                                            setIsCardValid(true);
                                                        }
                                                    }}
                                                    onReady={() => {
                                                        console.log('Card component ready');
                                                        setIsCardReady(true);
                                                        setIsCardValid(false); // Reset validity when component is ready
                                                    }}
                                                    onBlur={() => {
                                                        console.log('Card component blurred');
                                                    }}
                                                    onFocus={() => {
                                                        console.log('Card component focused');
                                                    }}
                                                />
                                            </Box>
                                            {cardError && (
                                                <Typography color="error" fontSize="12px" mt={1}>
                                                    {cardError}
                                                </Typography>
                                            )}
                                        </Box>
                                        <Box display="flex" justifyContent="end" flexDirection="column">
                                            {!showPromoField ? (
                                                <>
                                                    {appliedPromo ? (
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '8px',
                                                                padding: '4px 8px !important',
                                                                backgroundColor: '#F0FFF4',
                                                                borderRadius: '4px',
                                                                width: 'fit-content',
                                                                marginLeft: 'auto'
                                                            }}
                                                        >
                                                            <Typography color="#1D9652" fontSize="14px">
                                                                {appliedPromo.code} applied
                                                            </Typography>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="16"
                                                                height="16"
                                                                viewBox="0 0 16 16"
                                                                fill="none"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    setAppliedPromo(null);
                                                                    setPromoCode('');
                                                                }}
                                                            >
                                                                <path d="M8 1C4.1 1 1 4.1 1 8C1 11.9 4.1 15 8 15C11.9 15 15 11.9 15 8C15 4.1 11.9 1 8 1ZM10.7 11.5L8 8.8L5.3 11.5L4.5 10.7L7.2 8L4.5 5.3L5.3 4.5L8 7.2L10.7 4.5L11.5 5.3L8.8 8L11.5 10.7L10.7 11.5Z" fill="#1D9652" />
                                                            </svg>
                                                        </Box>
                                                    ) : (
                                                        null
                                                        // <Typography
                                                        //     color="#2B2B30"
                                                        //     fontSize="16px"
                                                        //     display="flex"
                                                        //     justifyContent="end"
                                                        //     mb="8px"
                                                        //     sx={{
                                                        //         cursor: 'pointer',
                                                        //         '&:hover': {
                                                        //             textDecoration: 'underline'
                                                        //         }
                                                        //     }}
                                                        //     onClick={() => setShowPromoField(true)}
                                                        // >
                                                        //     Have a promo code?
                                                        // </Typography>
                                                    )}
                                                </>
                                            ) : (
                                                <TextField
                                                    variant="outlined"
                                                    placeholder="Promo Code:"
                                                    value={promoCode}
                                                    onChange={(e) => {
                                                        setPromoCode(e.target.value);
                                                        setPromoError('');
                                                    }}
                                                    error={!!promoError}
                                                    helperText={promoError}
                                                    sx={{
                                                        width: "100%",
                                                        marginBottom: "25px",
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: '3px',
                                                            borderColor: '#C7C7C7',
                                                            background: '#ffffff',
                                                            paddingRight: '0'
                                                        },
                                                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: '#333333',
                                                            border: '1px solid'
                                                        },
                                                        "& .MuiOutlinedInput-input": {
                                                            padding: '14px 16px',
                                                            background: '#ffffff',
                                                            borderRadius: '8px'
                                                        },
                                                        "&.MuiInputBase-input::placeholder": {
                                                            color: '#333333',
                                                            fontSize: '16px',
                                                            opacity: '0.8'
                                                        },
                                                    }}
                                                    slotProps={{
                                                        input: {
                                                            endAdornment: (
                                                                <InputAdornment
                                                                    position="end"
                                                                    sx={{
                                                                        ".MuiTypography-root": {
                                                                            color: "#333333",
                                                                            fontWeight: "500",
                                                                            fontSize: "16px",
                                                                        },
                                                                        paddingRight: "10px",
                                                                    }}
                                                                >
                                                                    <Box display="flex" justifyContent="center" alignItems="center">
                                                                        <Box
                                                                            sx={{
                                                                                background: "#4058FB",
                                                                                borderRadius: '4px',
                                                                                padding: '4px 10px',
                                                                                marginRight: '4px',
                                                                                minWidth: '57px',
                                                                                fontSize: '14px',
                                                                                fontWeight: '500',
                                                                                color: '#fff',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                            onClick={validateCoupon}
                                                                        >
                                                                            Apply
                                                                        </Box>
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="17"
                                                                            height="16"
                                                                            viewBox="0 0 17 16"
                                                                            fill="none"
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => {
                                                                                setShowPromoField(false);
                                                                                setPromoError('');
                                                                            }}
                                                                        >
                                                                            <path d="M8.07324 1C4.17324 1 1.07324 4.1 1.07324 8C1.07324 11.9 4.17324 15 8.07324 15C11.9732 15 15.0732 11.9 15.0732 8C15.0732 4.1 11.9732 1 8.07324 1ZM10.7732 11.5L8.07324 8.8L5.37324 11.5L4.57324 10.7L7.27324 8L4.57324 5.3L5.37324 4.5L8.07324 7.2L10.7732 4.5L11.5732 5.3L8.87324 8L11.5732 10.7L10.7732 11.5Z" fill="#A3A3A3" />
                                                                        </svg>
                                                                    </Box>
                                                                </InputAdornment>
                                                            ),
                                                        },
                                                    }}
                                                />
                                            )}
                                        </Box>

                                        <Box sx={{
                                            flex: 1, position: 'relative', '@media (max-width: 768px)': {
                                                width: '100%',
                                            }
                                        }} display="flex" flexDirection="column" justifyContent="space-between">
                                            <Box>
                                                {/* Subdomain field - Hidden in SSO Flow */}
                                                {!isSSOFlow && (
                                                    <Box mb="8px">
                                                        <Typography color='#667085' fontSize='15px' marginBottom="8px">Your Custom URL</Typography>
                                                        <TextField
                                                            variant="outlined"
                                                            placeholder="https://your-brand.easywebinar.live"
                                                            value={formData.subdomain || ''}
                                                            onChange={(e) => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    subdomain: e.target.value.toLowerCase()
                                                                }));
                                                                // Clear error when user starts typing
                                                                setFormErrors(prev => ({
                                                                    ...prev,
                                                                    subdomain: ''
                                                                }));
                                                            }}
                                                            error={!!formErrors.subdomain}
                                                            helperText={formErrors.subdomain}
                                                            sx={{
                                                                width: "100%",
                                                                "& .MuiOutlinedInput-root": {
                                                                    borderRadius: '3px',
                                                                    borderColor: '#C7C7C7',
                                                                    background: '#ffffff',
                                                                    paddingRight: '0'
                                                                },

                                                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                    borderColor: '#333333',
                                                                    border: '1px solid'
                                                                },

                                                                "& .MuiOutlinedInput-input": {
                                                                    padding: '11px 14px',
                                                                    background: '#ffffff',
                                                                    borderRadius: '8px'
                                                                },
                                                                "&.MuiInputBase-input::placeholder": {
                                                                    color: '#333333',
                                                                    fontSize: '16px',
                                                                    opacity: '0.8'
                                                                },
                                                            }}
                                                            slotProps={{
                                                                input: {
                                                                    endAdornment: (
                                                                        <InputAdornment
                                                                            position="end"
                                                                            sx={{
                                                                                ".MuiTypography-root": {
                                                                                    color: "#333333",
                                                                                    fontWeight: "500",
                                                                                    fontSize: "16px",
                                                                                },

                                                                                paddingRight: "19px",
                                                                            }}
                                                                        >
                                                                            .easywebinar.live
                                                                        </InputAdornment>
                                                                    ),
                                                                },
                                                            }}
                                                        />
                                                    </Box>
                                                )}
                                                {/* Domain suggestions - Hidden in SSO Flow */}
                                                {!isSSOFlow && domainSuggestions.length > 0 && (
                                                    <Box mt={1} mb={2}>
                                                        <Typography color="primary" fontSize="12px" mb={1}>
                                                            Available alternatives:
                                                        </Typography>
                                                        <Box display="flex" gap={0.5} flexWrap="wrap">
                                                            {domainSuggestions.map((suggestion, index) => (
                                                                <Button
                                                                    key={index}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            subdomain: suggestion
                                                                        }));
                                                                        setFormErrors(prev => ({
                                                                            ...prev,
                                                                            subdomain: ''
                                                                        }));
                                                                        setDomainSuggestions([]);
                                                                    }}
                                                                    sx={{
                                                                        textTransform: 'none',
                                                                        borderColor: '#D0D5DD',
                                                                        color: '#344054',
                                                                        padding: '2px 8px',
                                                                        minHeight: '24px',
                                                                        fontSize: '12px',
                                                                        '&:hover': {
                                                                            borderColor: '#667085',
                                                                            backgroundColor: '#F9FAFB'
                                                                        }
                                                                    }}
                                                                >
                                                                    {suggestion}
                                                                </Button>
                                                            ))}
                                                        </Box>
                                                    </Box>
                                                )}
                                                {/* URL Guidelines - Hidden in SSO Flow */}
                                                {!isSSOFlow && !planId && <Box borderRadius="8px" bgcolor="#EDF6FF" p="24px 12px" color="#5A5475" >
                                                    <Typography variant="body2" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)">URL Guidelines:</Typography>
                                                    <Box>
                                                        <Box component="ul" sx={{ "& li": { listStyle: "disc", fontSize: "min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" } }} pl="20px" mt="24px" lineHeight="1.5">
                                                            <Box component="li">
                                                                Use lowercase letters, numbers and hyphens only
                                                            </Box>
                                                            <Box component="li">
                                                                3-30 characters long
                                                            </Box>
                                                            <Box component="li">
                                                                No spaces or special characters
                                                            </Box>
                                                            <Box component="li">
                                                                Cannot start or end with a hyphen
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>}
                                                <Box display="flex" gap={{ xs: "13px", sm: "119px" }} justifyContent="center" alignItems="center" mt={{ xs: "20px", md: '42px' }}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => handleGetStarted('default')}
                                                        className="x-large-btn"
                                                        disabled={isLoading || (!isTrial && !isCardValid)}
                                                        disableElevation
                                                        fullWidth
                                                        sx={{
                                                            textTransform: "capitalize",
                                                            px: "44px",
                                                            height: "47px!important",
                                                            fontSize: "18px",
                                                            bgcolor: "#4058FB !important",
                                                            "&:hover": { bgcolor: "#2E3FD9 !important" },
                                                            "&.Mui-disabled": {
                                                                bgcolor: "#cccccc !important",
                                                                color: "#666666 !important"
                                                            }
                                                        }}
                                                    >
                                                        {isLoading ? (
                                                            <CircularProgress size={24} sx={{ color: 'white' }} />
                                                        ) : !isTrial && !isCardValid ? (
                                                            'Please complete card details'
                                                        ) : (
                                                            'Start 7-day free trial'
                                                        )}
                                                    </Button>
                                                </Box>
                                            </Box>
                                            <Box
                                                sx={{
                                                    textAlign: 'center',
                                                    mt: 2,
                                                    mb: 2
                                                }}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: '#374151',
                                                        fontSize: '14px',
                                                        fontWeight: 400,
                                                        lineHeight: 1.5,
                                                    }}
                                                >
                                                    100% Free Trial • Cancel Anytime • No Hidden Fees
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: '#374151',
                                                        fontSize: '10px',
                                                        fontWeight: 400,
                                                        lineHeight: 1.5,
                                                        mt: 2,
                                                    }}
                                                >
                                                    By starting your trial, you agree to our <a href="https://easywebinar.com/terms-conditions/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Terms of Service</a> and <a href="https://easywebinar.com/privacy/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Privacy Policy</a>
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box >
                            </>
                        )}
                    </Box>
                </Box>
            </Box>
            <AccountVerification
                onClose={handleVerificationDialogClose}
                open={verificationDialogOpen}
                onProceed={handleVerificationDialogProceed}
                phoneNumber=""
                email={formData.email}
                password={formData.password}
                companyId={verificationData.companyId}
                companyName={verificationData.companyName}
                infLeadSquaredId={verificationData.infLeadSquaredId}
                />
        </>
    )
}
export default Signup2ndFlow
